

// import React from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import {
//   Chart,
//   getElementsAtEvent,
//   getDatasetAtEvent,
//   getElementAtEvent,
// } from "react-chartjs-2";
// import {
//   addDays,
//   endOfDay,
//   startOfDay,
//   startOfYear,
//   startOfMonth,
//   endOfMonth,
//   endOfYear,
//   addMonths,
//   subMonths,
//   addYears,
//   startOfWeek,
//   endOfWeek,
//   isSameDay,
//   differenceInCalendarDays,
// } from "date-fns";
// import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import { useEffect, useMemo } from "react";
// import { toast } from "react-toastify";
// import { useState, useRef } from "react";
// import {
//   Backdrop,
//   Button,
//   IconButton,
//   Popover,
//   Skeleton,
//   MenuItem,
// } from "@mui/material";
// import Loader from "../../../components/Loader";
// import moment from "moment";
// import { common_axios } from "../../../App";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import RefreshIcon from "@mui/icons-material/Refresh";
// import Swal from "sweetalert2";
// import DateRangeIcon from "@mui/icons-material/DateRange";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import StopCircleIcon from "@mui/icons-material/StopCircle";
// import CancelImg from "../../../assets/images/cancel.png";
// import { setTimeSeries1 } from "../../../redux/features/dashboardSlice";
// import { setTimeSeries2 } from "../../../redux/features/dashboardSlice";
// import { actionid } from "../../../redux/features/pageSlices";
// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import PersonIcon from "@mui/icons-material/Person";
// import ForwardIcon from "@mui/icons-material/Forward";
// import DownloadingSharpIcon from "@mui/icons-material/DownloadingSharp";
// import { CircularProgress } from "@mui/material";
// import Box from "@mui/material/Box";
// import { Link } from "react-router-dom";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import BlockIcon from "@mui/icons-material/Block";
// import SystemSecurityUpdateWarningIcon from "@mui/icons-material/SystemSecurityUpdateWarning";
// // import Popover from "@mui/icons-material/Popover";
// import DateRangePickerTransactional from "../Reports/Transcational/DateRangePickerTransactional";
// import html2canvas from "html2canvas";
// import { jsPDF } from "jspdf";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import DateRangePickerGraph from "./DateRancePickerGraph";
// import Menu from "@mui/material/Menu";
// import ShowChartIcon from '@mui/icons-material/ShowChart';
// import BarChartIcon from '@mui/icons-material/BarChart';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import AssessmentIcon from '@mui/icons-material/Assessment';
// import ImageIcon from '@mui/icons-material/Image';
// import DescriptionIcon from '@mui/icons-material/Description';
// import * as XLSX from "xlsx";
// import {
//   useAsyncDebounce,
//   useBlockLayout,
//   useColumnOrder,
//   useFilters,
//   useGlobalFilter,
//   usePagination,
//   useRowSelect,
//   useSortBy,
//   useTable,
// } from "react-table";
// import { message } from "antd";
// import { number } from "yup";
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

// // import DateRangePickerTransactional from "./DateRangePickerTransactional";

// const generateLegendHtml = (chart) => {
//   const { datasets } = chart.data;
//   let legendHtml = "";

//   datasets.forEach((dataset, index) => {
//     const backgroundColor = dataset.backgroundColor[index];
//     const label = dataset.label;

//     // console.log({ label });

//     legendHtml += `
//       <div class="custom-legend">
//         <span class="legend-color" style="background-color: ${backgroundColor}"></span>
//         <span class="legend-label">${label}</span>
//       </div>
//     `;
//   });

//   return "this";
// };

// export function Successgraph() {
//   const value = localStorage.getItem("dstQueCode1")?.split(",");
//   const resd = useSelector((data) => data?.dashboardReducer);

//   const [dataGraph, setDataGraph] = useState(null);
//   const [data, setData] = useState([
//     // {
//     //   file_status: 1,
//     //   delivered: 0,
//     //   daily_Code: "2023-07-05",
//     //   "Message Sent": 0,
//     //   "Successfully Submited": 0,
//     //   Download:
//     //     "http://192.168.146.187:4902/sms/delivery-report/v1/download/transactional/130_2023_08_03_180730.xlsx",
//     // },
//     // {
//     //   file_status: null,
//     //   delivered: 0,
//     //   daily_Code: "2023-07-08",
//     //   "Message Sent": 0,
//     //   "Successfully Submited": 0,
//     //   Download: null,
//     // },
//   ]);

//  console.log("uy9uyhjoh", dataGraph);
//   const [open, setOpen] = useState(true);
//   const [open1, setOpen1] = useState(false);
// const[barIcons,setBarIcons] = useState("line")
//   const chartRef = useRef();
//   const history = useHistory();
//   const [data1, setData1] = useState([]);
//   // console.log("ff", resd);
//   const [globlecancel, setgloblecancel] = useState(false);

//   const Tabs = localStorage.getItem("dashboardTopTabs");
//   const dispatch = useDispatch();
//   const [anchorEll, setAnchorEll] = React.useState(null);
//   // const [TodayGraphApiNotHit, setTodayGraphApiNotHit] = useState(false);
//   const [TodayGraphApiNotHit, setTodayGraphApiNotHit] = useState(
//     Tabs == "3" || Tabs == "4" ? false : true
//   );
//   const selectedTime = useSelector(
//     (state) => state.dashboardReducer.timeSeries2
//   );
//   const [Status, setStatus] = useState({
//     approveType: selectedTime?.approveType
//       ? selectedTime?.approveType
//       : "Completed",
//     resellerName: null,
//     type: null,
//     approveAssignedType: null,
//     hideShow: false,
//     pageNo: 0,
//     pageSize: 10,
//     selectorType: null,
//     startTime: null,
//     tabs: 0,
//     dateTabs0: null,
//   });
  
// console.log("khjj",Status.pageNo)
//   const [TableStatus, setTableStatus] = useState({
//     hideShow: false,
//     pageNo: 0,
//     pageSize: 10,
//   });
//   const [byDefaultTableApiNotHit, setByDefaultTableApiNotHit] = useState(false);

//   const [paginationPage, setPaginationPage] = React.useState(1);
//   const [loadingIndex, setLoadingIndex] = useState(-1);

//   const handleLegendClick = (event, legendItem) => {
//     // Access the clicked legend item
//     legendItem.hidden = true;
//   };

//   const options = {
//     responsive: true,
//     interaction: {
//       mode: "index",
//       intersect: false,
//     },

//     legend: {
//       // display: false,
//       // onClick: handleLegendClick,
//     },
//     stacked: false,
//     //   plugins: {
//     //     title: {
//     //       display: true,
//     //       text: "Approved Sender Id Types",
//     //     },
//     //   },

//     plugins: {
//       legend: {
//         display: false,
//       },
//       tooltip: {
//         callbacks: {
//           title: (xDatapoint) => {
//             if (isNaN(xDatapoint?.[0].label)) {
//               return xDatapoint?.[0].label;
//             } else {
//               // var dateObj = new Date();
//               // var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
//               // var year = dateObj.getUTCFullYear();

//               // const newdate = xDatapoint?.[0].label + "/" + month1 + "/" + year;

//               // return newdate;

//               return dataGraph?.labelsName?.[xDatapoint?.[0]?.dataIndex];
      
//             }
//           },
//           // label: (yDatapoint) => {
//           //   console.log({ yDatapoint }); // All list shown in color
//           //   return "22";
//           // },
//         },
//       },
//       datalabels: {
//         display: true,
//         color: "transparent",
//         align: "top",
//         padding: {
//           right: 2,
//         },
      
//         labels: {
//           padding: { top: 10 },
//           title: {
//             font: {
//               weight: "bold",
//             },
//           },
//           value: {
//             color: "transparent",
//           },
//         },
//         formatter: function (value) {
//           return "\n" + value;
//         },
//       },
//     },

//     onHover: (event, activeElements) => {
//       // console.log({ activeElements });
//       if (activeElements?.length > 0) {
//         event.native.target.style.cursor = "pointer";
//       } else {
//         event.native.target.style.cursor = "auto";
//       }
//     },
//     scales: {
//       y: {
//         type: "linear",
//         display: true,
//         position: "left",
//         ticks: {
//           min: 0,
//           max: 1,
//           stepSize: 1,
//           fontSize: 20,
//         },
//         title: {
//           display: true,
//           text: "<---- Count ---->",
//           // color: "#911",
//           font: {
//             family: "Poppins, sans-serif",
//             size: 20,
//             weight: "bolder",
//             lineHeight: 1.2,
//           },
//         },
//       },
//       x: {
//         stacked: true,
//         maxTicksLimit: 11,
//         title: {
//           display: true,
//           text: `<---- ${
//             (Tabs == 3 || Tabs == 4) && TodayGraphApiNotHit == false
//               ? "Hours"
//               : "Month"
//           } ---->`,
//           font: {
//             family: "Poppins, sans-serif",
//             size: 20,
//             weight: "bolder",
//             lineHeight: 1.2,
//           },
//         },
//       },
//       // x1: {
//       //   ticks: {
//       //     // For a category axis, the val is the index so the lookup via getLabelForValue is needed
//       //     callback: function (val, index) {
//       //       // Hide every 2nd tick label
//       //       console.log(
//       //         "TTTTTTTT",
//       //         Math.floor(data?.labels?.length / 2),
//       //         index,
//       //         Math.floor(data?.labels?.length / 2) === index,
//       //         data
//       //       );
//       //       return Math.floor(data?.labels?.length / 2) === index
//       //         ? "Campaign Type"
//       //         : null;
//       //     },
//       //   },
//       // },

//       // y1: {
//       //   type: "linear",
//       //   display: true,
//       //   position: "right",
//       //   grid: {
//       //     drawOnChartArea: false,
//       //   },
//       // },
//     },
//   };
//   const [rowData, setRowData] = useState([]);
//   const [labelDate, setLabelDate] = useState([]);
//   const assignUserApi = async (e) => {
//     var date = moment(resd?.timeSeries?.end);
//     var now = moment(resd?.timeSeries?.start);
//     var duration = moment.duration(date.diff(now));
//     var noofDays = duration.asDays();
//     if (value[1] == "successM") {
//       setDataGraph([]);

//       try {
//         setOpen(true);
//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/table/graph`,
//           {
//             dashBoardRequest: {
//               startDate: resd?.timeSeries2?.start,
//               endDate: resd?.timeSeries2?.end,
//               // startDate: "2023-08-01",
//               // endDate: "2023-08-31",
//               flag: "Success",
//             },
//           }
//         );
//         if (res.data?.statusDescription?.statusCode == 200) {
//           // setData1(res.data);
//           // TableDataGet1();
//           setOpen(false);

//           setRowData(res.data?.dataSets);
//           setLabelDate(res.data.xaxisLabelDate);
//           if (res.data?.dataSets?.length == 0) {
//             setDataGraph([]);
//           } else {
//             res.data["dataSets1"] = [];
//             let varrr = false;
//             for (let index = 0; index < res.data?.dataSets.length; index++) {
//               res.data.dataSets[index]["pointRadius"] = 0;
//               res.data.dataSets[index]["clicked"] = true;

//               if (res.data.dataSets[index].label == "Pushed To SMSC") {
//                 res.data.dataSets[index]["backgroundColor"] = "#f9442f";
//                 res.data.dataSets[index]["borderColor"] = "#f9442f";
//                 res.data.dataSets[index]["icon"] = StopCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;
//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#f9442f";
//               }

//               if (res.data.dataSets[index].label == "Delivered") {
//                 res.data.dataSets[index]["backgroundColor"] = "#5ab778";
//                 res.data.dataSets[index]["borderColor"] = "#5ab778";
//                 res.data.dataSets[index]["icon"] = CheckCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;

//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#5ab778";
//               }
//               for (
//                 let i = 0;
//                 i < res.data?.dataSets[index]?.data?.length;
//                 i++
//               ) {
//                 if (res.data?.dataSets[index]?.data[i] != 0) {
//                   varrr = true;
//                 }
//               }
//             }
//             if (!varrr) {
//               setDataGraph([]);
//             } else {
//               if (value[1] == "successM") {
//                 setDataGraph({
//                   labels: res.data?.xaxisLabelDate,
//                   labelsName: res.data?.xaxisLabelDate,
//                   labelsNumber: res.data?.xaxisLabels,
//                   datasets: res.data?.dataSets1,

//                   // datasets: [
//                   //   {
//                   //     label: "Pending for Approval",
//                   //     data: [65, 29, 80, 31, 56, 39, 41, 65, 22, 89, 81],
//                   //     borderColor: "#39CCCC",
//                   //     // backgroundColor: "rgb(0,0,135)",
//                   //     backgroundColor: "#39CCCC",
//                   //     yAxisID: "y",
//                   //     tension: 0.5,
//                   //   },
//                   //   {
//                   //     label: "Active",
//                   //     data: [76, 29, 92, 61, 60, 52, 46, 87, 59, 90, 81],
//                   //     borderColor: "#D81B60",
//                   //     // backgroundColor: "rgb(117,217,239)",
//                   //     backgroundColor: "#D81B60",
//                   //     yAxisID: "y1",
//                   //     tension: 0.5,
//                   //   },
//                   //   {
//                   //     label: "In Process",
//                   //     data: [50, 17, 60, 44, 26, 14, 29, 15, 59, 89, 51],
//                   //     borderColor: "#FF851B",
//                   //     // backgroundColor: "rgb(80,108,120)",
//                   //     backgroundColor: "#FF851B",
//                   //     yAxisID: "y1",
//                   //     tension: 0.5,
//                   //   },
//                   //   {
//                   //     label: "Rejected",
//                   //     data: [10, 9, 37, 41, 21, 28, 11, 35, 24, 67, 61],
//                   //     borderColor: "#605CA8)",
//                   //     // backgroundColor: "rgb(216,217,221)",
//                   //     backgroundColor: "#605CA8",
//                   //     yAxisID: "y1",
//                   //     tension: 0.5,
//                   //   },
//                   // ],
//                 });
//               }
//             }
//           }
//           // setOpen(false);
//         } else {
//           setDataGraph([]);
//           setOpen(false);
//         }
//       } catch (error) {
//         setDataGraph([]);
//         setOpen(false);
//         // console.log(error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } else {
//       setDataGraph([]);

//       try {
//         setOpen(true);
//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/table/graph`,
//           {
//             dashBoardRequest: {
//               // startDate: "2023-08-01",
//               // endDate: "2023-08-31",
//               startDate: resd?.timeSeries2?.start,
//               endDate: resd?.timeSeries2?.end,
//               flag: "Failed",
//             },
//           }
//         );

//         if (res.data?.statusDescription.statusCode == 200) {
//           // TableDataGet1();

//           setRowData(res.data?.dataSets);
//           setLabelDate(res.data.xaxisLabelDate);
//           setOpen(false);

//           if (res.data?.dataSets?.length == 0) {
//             setDataGraph([]);
//           } else {
//             let varrr = false;
//             res.data["dataSets1"] = [];
//             for (let index = 0; index < res.data?.dataSets?.length; index++) {
//               res.data.dataSets[index]["pointRadius"] = 0;
//               res.data.dataSets[index]["clicked"] = true;

//               if (res.data.dataSets[index].label == "Dnd") {
//                 res.data.dataSets[index]["backgroundColor"] = "#536878";
//                 res.data.dataSets[index]["borderColor"] = "#536878";
//                 res.data.dataSets[index]["icon"] = BlockIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;

//                 res.data.dataSets[index]["pointHoverRadius"] = 6;
//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#536878";
//               }
//               if (res.data.dataSets[index].label == "Blacklist") {
//                 res.data.dataSets[index]["backgroundColor"] = "#221133";
//                 res.data.dataSets[index]["borderColor"] = "#221133";
//                 res.data.dataSets[index]["icon"] = CancelIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;
//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#221133";
//               }
//               if (res.data.dataSets[index].label == "Nack") {
//                 res.data.dataSets[index]["backgroundColor"] = "#a40000";
//                 res.data.dataSets[index]["borderColor"] = "#a40000";
//                 res.data.dataSets[index]["icon"] = CheckCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;

//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#a40000";
//               }

//               if (res.data.dataSets[index].label == "System Error") {
//                 res.data.dataSets[index]["backgroundColor"] = "#f9442f";
//                 res.data.dataSets[index]["borderColor"] = "#f9442f";
//                 res.data.dataSets[index]["icon"] =
//                   SystemSecurityUpdateWarningIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;

//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#f9442f";
//               }
//               if (res.data.dataSets[index].label == "Message Sent") {
//                 res.data.dataSets[index]["backgroundColor"] = "#f9442f";
//                 res.data.dataSets[index]["borderColor"] = "#f9442f";
//                 res.data.dataSets[index]["icon"] = StopCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//               }
//               if (res.data.dataSets[index].label == "Waiting For ACK") {
//                 res.data.dataSets[index]["backgroundColor"] = "orange";
//                 res.data.dataSets[index]["borderColor"] = "orange";
//                 res.data.dataSets[index]["icon"] = CheckCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;
//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "orange";
//               }
//               if (res.data.dataSets[index].label == "Delivered") {
//                 res.data.dataSets[index]["backgroundColor"] = "#5ab778";
//                 res.data.dataSets[index]["borderColor"] = "#5ab778";
//                 res.data.dataSets[index]["icon"] = CheckCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//               }
//               for (
//                 let i = 0;
//                 i < res.data?.dataSets[index]?.data?.length;
//                 i++
//               ) {
//                 if (res.data?.dataSets[index]?.data[i] != 0) {
//                   varrr = true;
//                 }
//               }
//             }
//             if (!varrr) {
//               setDataGraph([]);
//             } else {
//               if (value[1] != "successM") {
//                 setDataGraph({
//                   labels: res.data?.xaxisLabelDate,

//                   datasets: res.data?.dataSets1,
//                 });
//               }
//             }
//           }
//           // setOpen(false);
//         } else {
//           setDataGraph([]);
//           setOpen(false);
//         }
//       } catch (error) {
//         // console.error({ error });

//         setDataGraph([]);

//         setOpen(false);
//         // console.log(error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     }
//   };
//   // useEffect(() => {
//   //   if ((Tabs == "3" || Tabs == "4" ) && TodayGraphApiNotHit == false) {
//   //     TodayGraphApi();
//   //     TodayTableDataGet();
//   //   } 
  
//   //   else {
//   //     assignUserApi();
//   //     TableDataGet1();
//   //   }
//   // }, [
//   //   resd?.timeSeries2?.start,
//   //   resd?.timeSeries2?.end,
//   //   resd?.product,
//   //   resd?.productType,
//   //   // resd?.showBy,
//   //   // value,
//   // ]);


//   useEffect(() => {
//     if ((Tabs == "3" || Tabs == "4") && TodayGraphApiNotHit == false) {
//       TodayGraphApi();
//       TodayTableDataGet();
//     }
//     // else if((Tabs == "0" || Tabs == "1" ) && TodayGraphApiNotHit == true) {
//     //   TodayGraphApi();
//     //   TodayTableDataGet();
//     // }
//     else {
//       if (TodayGraphApiNotHit == true) {
//         assignUserApi();
//         TableDataGet1();
//       } else {
//         TodayGraphApi();
//         TodayTableDataGet();
//       }
//     }
//   }, [
//     resd?.timeSeries2?.start,
//     resd?.timeSeries2?.end,
//     resd?.product,
//     resd?.productType,

//     // resd?.showBy,
//     // value,
//   ]);


// // useEffect(()=>{
// // if(Tabs == "0" || Tabs == "1"){
// //   setTodayGraphApiNotHit(true)
// // } 
// // },[Tabs])

//   // console.log("ddd", Tabs);

//   const globalData = useSelector((state) => state.dashboardReducer);

//   const printDatasetAtEvent = (dataset) => {
//     if (!dataset.length) return;

//     const datasetIndex = dataset[0].datasetIndex;

//     // console.log(data.datasets[datasetIndex].status);

//     return dataGraph.datasets[datasetIndex].status;
//   };

//   const printElementAtEvent = (element) => {
//     if (!element.length) return;

//     const { datasetIndex, index } = element[0];

//     // console.log(data.labels[index], data.datasets[datasetIndex].data[index]);
//     return dataGraph.labels[index];
//   };

//   const printElementsAtEvent = (elements) => {
//     if (!elements.length) return;

//     // console.log(elements.length);
//     return elements.length;
//   };

//   const printElementIndexAtEvent = (element) => {
//     if (!element.length) return;

//     const { datasetIndex, index } = element[0];

//     return [index];
//   };

//   const handleClick = (event) => {
//     // console.log("mm", getDatasetAtEvent(chartRef.current, event),printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)),printElementAtEvent(getElementAtEvent(chartRef.current, event)), printElementIndexAtEvent(
//     //   getElementAtEvent(chartRef.current, event)
//     // ))
//     // console.log("first",printElementAtEvent(getElementAtEvent(chartRef.current, event)),)
//     //  alert("Now clikced");
//     // console.log("aaa",dataGraph.datasets[getDatasetAtEvent(chartRef.current, event)[0].datasetIndex])

//     let Datee = printElementAtEvent(getElementAtEvent(chartRef.current, event));
//     let Labell =
//       dataGraph.datasets[
//         getDatasetAtEvent(chartRef.current, event)[0].datasetIndex
//       ];
//     localStorage.setItem("GraphPointer", `${Datee},${Labell.label}`);

//     // console.log(
//     //   "IIIIIIII",
//     //   printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)),
//     //   printElementAtEvent(getElementAtEvent(chartRef.current, event)),
//     //   !isNaN(
//     //     data?.labelsNumber?.[
//     //       printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
//     //     ]
//     //   )
//     // );
//     var dateObj = new Date();
//     var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
//     var year = dateObj.getUTCFullYear();

//     const newdate =
//       year +
//       "-" +
//       month1 +
//       "-" +
//       printElementAtEvent(getElementAtEvent(chartRef.current, event));

//     // if (printElementAtEvent(getElementAtEvent(chartRef.current, event))) {
//     //   localStorage?.setItem(
//     //     "dstQueCode1",
//     //     `${newdate},${printDatasetAtEvent(
//     //       getDatasetAtEvent(chartRef.current, event)
//     //     )}`
//     //   );

//     // }

//     if (
//       // !isNaN(printElementAtEvent(getElementAtEvent(chartRef.current, event)))
//       !isNaN(
//         dataGraph?.labelsNumber?.[
//           printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
//         ]
//       )
//     ) {
//       var dateObj = new Date();
//       var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
//       var year = dateObj.getUTCFullYear();

//       const newdate =
//         year +
//         "-" +
//         month1 +
//         "-" +
//         printElementAtEvent(getElementAtEvent(chartRef.current, event));

//       if (printElementAtEvent(getElementAtEvent(chartRef.current, event))) {
//         // localStorage?.setItem(
//         //   "dstQueCode1",
//         //   `${newdate},${printDatasetAtEvent(
//         //     getDatasetAtEvent(chartRef.current, event)
//         //   )},${value}`
//         // );

//         // localStorage?.setItem(
//         //   "dstQueCode1",
//         //   `${
//         //     dataGraph?.labelsName?.[
//         //       printElementIndexAtEvent(
//         //         getElementAtEvent(chartRef.current, event)
//         //       )
//         //     ]
//         //   },${printDatasetAtEvent(
//         //     getDatasetAtEvent(chartRef.current, event)
//         //   )},${value}`
//         // );

//         if (
//           printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)) == 1
//         ) {
//           if (
//             JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//             "ROLE_SUPER_ADMIN"
//           ) {
//             dispatch(actionid("1"));
//             document
//               .getElementsByName("sidebarLiCampaign Manager")?.[0]
//               ?.click();
//             history.replace("/dashboard/CampaignsControl");
//           } else {
//             dispatch(actionid("1"));
//             document
//               .getElementsByName("sidebarLiCampaign Manager")?.[0]
//               ?.click();
//             history.replace("/dashboard/CampaignControl");
//           }
//         } else {
//           // dispatch(
//           //   setTimeSeries2({
//           //     end: `${
//           //       dataGraph?.labelsName?.[
//           //         printElementIndexAtEvent(
//           //           getElementAtEvent(chartRef.current, event)
//           //         )
//           //       ]
//           //     }`,

//           //     start: `${
//           //       dataGraph?.labelsName?.[
//           //         printElementIndexAtEvent(
//           //           getElementAtEvent(chartRef.current, event)
//           //         )
//           //       ]
//           //     }`,
//           //     dateType: "Daily",
//           //     approveType:
//           //       printDatasetAtEvent(
//           //         getDatasetAtEvent(chartRef.current, event)
//           //       ) == 5
//           //         ? "Stopped"
//           //         : "Completed",
//           //   })
//           // );
//           document.getElementsByName("sidebarLiReports")?.[0]?.click();
//           // history?.push("/dashboard/SuccessGraphAll");
//           if (value[1] == "successM") {
//             history?.push("/dashboard/SuccessGraph/SuccessGraphReports");
//           } else {
//             history?.push("/dashboard/FailedGraph/FailedGraphReports");
//           }
//         }
//       } else {
//       }
//     } else {
//       // console.log(
//       //   "PPPPPP",

//       //   moment()
//       //     .month(
//       //       printElementAtEvent(getElementAtEvent(chartRef.current, event))
//       //     )
//       //     .format("M"),
//       //   moment().format("M"),
//       //   typeof moment().month("feb").format("M")
//       // );

//       if (
//         Number(
//           moment()
//             .month(
//               printElementAtEvent(getElementAtEvent(chartRef.current, event))
//             )
//             .format("M")
//         ) <= Number(moment().format("M"))
//       ) {
//         const endDate = moment(
//           moment().month(
//             printElementAtEvent(getElementAtEvent(chartRef.current, event))
//           )
//         )
//           .endOf("month")
//           .format("YYYY-MM-DD");
//         const startDate = moment(
//           moment().month(
//             printElementAtEvent(getElementAtEvent(chartRef.current, event))
//           )
//         )
//           .startOf("month")
//           .format("YYYY-MM-DD");
//         // localStorage?.setItem(
//         //   "dstQueCode1",
//         //   `${startDate},${printDatasetAtEvent(
//         //     getDatasetAtEvent(chartRef.current, event)
//         //   )},${value},${endDate}`
//         // );
//         if (getDatasetAtEvent(chartRef.current, event) == 1) {
//           if (
//             JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//             "ROLE_SUPER_ADMIN"
//           ) {
//             dispatch(actionid("1"));
//             document
//               .getElementsByName("sidebarLiCampaign Manager")?.[0]
//               ?.click();
//             history.replace("/dashboard/CampaignsControl");
//           } else {
//             dispatch(actionid("1"));
//             document
//               .getElementsByName("sidebarLiCampaign Manager")?.[0]
//               ?.click();
//             history.replace("/dashboard/CampaignControl");
//           }
//         } else {
//           // dispatch(
//           //   setTimeSeries2({
//           //     end: `${endDate}`,
//           //     start: `${startDate}`,
//           //     dateType: "Daily",
//           //     approveType:
//           //       printDatasetAtEvent(
//           //         getDatasetAtEvent(chartRef.current, event)
//           //       ) == 5
//           //         ? "Stopped"
//           //         : "Completed",
//           //   })
//           // );
//           document.getElementsByName("sidebarLiReports")?.[0]?.click();
//           // history?.push("/dashboard/SuccessGraphAll");
//           if (value[1] == "successM") {
//             history?.push("/dashboard/SuccessGraph/SuccessGraphReports");
//           } else {
//             history?.push("/dashboard/FailedGraph/FailedGraphReports");
//           }
//         }
//       } else {
//         const endDate = moment(
//           moment(
//             moment().month(
//               printElementAtEvent(getElementAtEvent(chartRef.current, event))
//             )
//           ).endOf("month")
//         )
//           .add(-1, "y")
//           .format("YYYY-MM-DD");
//         const startDate = moment(
//           moment(
//             moment().month(
//               printElementAtEvent(getElementAtEvent(chartRef.current, event))
//             )
//           ).startOf("month")
//         )
//           .add(-1, "y")
//           .format("YYYY-MM-DD");

//         // localStorage?.setItem(
//         //   "dstQueCode1",
//         //   `${startDate},${printDatasetAtEvent(
//         //     getDatasetAtEvent(chartRef.current, event)
//         //   )},${value},${endDate}`
//         // );
//         if (getDatasetAtEvent(chartRef.current, event) == 1) {
//           if (
//             JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//             "ROLE_SUPER_ADMIN"
//           ) {
//             dispatch(actionid("1"));
//             document
//               .getElementsByName("sidebarLiCampaign Manager")?.[0]
//               ?.click();
//             history.replace("/dashboard/CampaignsControl");
//           } else {
//             dispatch(actionid("1"));
//             document
//               .getElementsByName("sidebarLiCampaign Manager")?.[0]
//               ?.click();
//             history.replace("/dashboard/CampaignControl");
//           }
//         } else {
//           // dispatch(
//           //   setTimeSeries2({
//           //     end: `${endDate}`,
//           //     start: `${startDate}`,
//           //     dateType: "Daily",
//           //     approveType:
//           //       printDatasetAtEvent(
//           //         getDatasetAtEvent(chartRef.current, event)
//           //       ) == 5
//           //         ? "Stopped"
//           //         : "Completed",
//           //   })
//           // );
//           document.getElementsByName("sidebarLiReports")?.[0]?.click();
//           // history?.push("/dashboard/SuccessGraphAll");
//           if (value[1] == "successM") {
//             history?.push("/dashboard/SuccessGraph/SuccessGraphReports");
//           } else {
//             history?.push("/dashboard/FailedGraph/FailedGraphReports");
//           }
//         }
//       }
//     }

//     // history?.push("/dashboard/TransactionalReports");
//     // printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event));
//     // printElementAtEvent(getElementAtEvent(chartRef.current, event));
//     // printElementsAtEvent(getElementsAtEvent(chartRef.current, event));
//   };

//   const handleButtonClick = (index) => {
//     // console.log(chartRef.current.data.dataset);
//     let dataaa = [...dataGraph?.datasets];
//     dataaa[index].clicked = !dataaa[index].clicked;
//     setDataGraph({
//       ...dataGraph,
//       datasets: dataaa,
//     });
//     chartRef.current.data.datasets[index].hidden =
//       !chartRef.current.data.datasets[index].hidden;
//     chartRef.current.update();
//   };

//   // ...................Table...............................................................................//

//   // console.log("coooo--", headerColumn);
//   // const columns = [
//   //   {
//   //     Header: "Name",
//   //     accessor: "name",
//   //   },
//   //   {
//   //     Header: "Age",
//   //     accessor: "age",
//   //   },
//   //   {
//   //     Header: "City",
//   //     accessor: "city",
//   //   },
//   // ];
//   const [columns, setColumns] = useState([]);
//   // console.log("co--==", columns);

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     // footerGroups,
//     rows,
//     page,
//     nextPage,
//     canNextPage,
//     previousPage,
//     canPreviousPage,
//     pageOptions,
//     gotoPage,
//     pageCount,
//     setPageSize,
//     prepareRow,
//     state,
//     setGlobalFilter,
//     selectedFlatRows,
//     setColumnOrder,
//     allColumns,
//     getToggleHideAllColumnsProps,
//   } = useTable(
//     {
//       columns,
//       data,
//     },
//     useFilters,
//     useGlobalFilter,
//     useSortBy,
//     usePagination,
//     useRowSelect
//   );
//   const { globalFilter, pageIndex, pageSize } = state;

//   const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

//   const onChange = useAsyncDebounce((value) => {
//     setGlobalFilter(value || undefined);
//   }, 1000);

//   const deletUser = () => {
//     // console.log({ selectedFlatRows });
//   };

//   const changeOrder = () => {
//     setColumnOrder(["id", "username", "action", "role", "email"]);
//   };
//   const [headerColumn, setHeaderColumn] = useState([]);
//   // console.log("co--", headerColumn, rowData);
//   const [serialNo, setSerialNo] = useState();
//   // ..................................GetApi.......................................................//
//   async function Tableget() {
//     // setData([]);
//     let temp = [];
//     let Sno = {
//       Header: "Id",
//       accessor: "id",
//       Cell: (cell) => {
//         // console.log(
//         //   "cell--==",
//         //   cell.row.index + 1,
//         //   cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize
//         // );
//         return (
//           <>
//             {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
//           </>
//         );
//       },
//     };
//     setSerialNo(Sno);
//     // let dateColumn = {

//     //     Header: "Date",

//     //     accessor: "Date",
//     //     Cell: (cell) => {
//     //       return (
//     //         <>
//     //           <Link

//     //             style={{
//     //               textDecoration: "underline",
//     //               // color: "blue",
//     //               fontWeight: "bolder",
//     //             }}
//     //             to={`/dashboard/TransactionalReport/All`}
//     //           >
//     //             {cell?.row?.original?.Date}
//     //           </Link>

//     //         </>
//     //       );

//     //   },
//     // }
//     let downloadColumn = {
//       Header: "Download",
//       accessor: "download",
//       // Cell: ({ row }) => (
//       //   <button>Download</button>
//       // ),
//       Cell: (cell) => {
//         return (
//           <>
//             {cell.row.original.Download == null ? (
//               <>
//                 <div className="">
//                   <button
//                     type="button"
//                     className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
//                     id="btn_Update"
//                     style={{ width: "auto" }}
//                     onClick={() => {
//                       DownloadAction(cell);
//                     }}
//                     // disabled={DownloadDisable}
//                   >
//                     {/* Download Request */}
//                     <DownloadingSharpIcon />
//                   </button>
//                 </div>
//               </>
//             ) : cell.row.original.Download === "" ? (
//               <>
//                 <Box
//                   sx={{ display: "block", width: "100px" }}
//                   className="mx-auto"
//                 >
//                   <CircularProgress style={{ width: "31px", height: "31px" }} />
//                 </Box>
//               </>
//             ) : (
//               <>
//                 <div className="">
//                   <button
//                     className="btn color_1 px-2"
//                     type="button"
//                     id=""
//                     data-bs-toggle=""
//                     aria-expanded="false"
//                     onClick={() => {
//                       downloadFile(cell);
//                     }}
//                   >
//                     <FileDownloadIcon />
//                   </button>
//                 </div>
//               </>
//             )}
//           </>
//         );
//       },
//     };
//     try {
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/status`,
//         {
//           status: value[1] == "successM" ? 3 : 2,
//         }
//       );
//       if (result.data.statusDescription.statusCode == 200) {
//         await setHeaderColumn(result.data.messageStatusTables);
//         temp.push(Sno);
       
//         // temp.push(dateColumn);
//         for (let i = 0; i < result.data.messageStatusTables.length; i++) {
//           // console.log("co--",result.data.messageStatusTables[i].columnName)
//          if (result.data.messageStatusTables[i].columnName == "S.No") {
//           }
//           else if (result.data.messageStatusTables[i].columnName == "Date") {
//             // alert("enter")
//            await temp.push({
//               Header: result.data.messageStatusTables[i].columnName,
//               accessor: result.data.messageStatusTables[i].columnName,
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {value[1] == "successM" ? (
//                       <>
//                         <Link
//                           style={{
//                             textDecoration: "underline",
//                             // color: "blue",
//                             fontWeight: "bolder",
//                           }}
//                           to={`/dashboard/SuccessGraph/SuccessGraphReports`}
//                           onClick={() => {
//                             localStorage.setItem(
//                               "dailyCode",
//                               `${cell.row.original.Date}`
//                             );
//                           }}
//                         >
//                           {cell?.row?.original?.Date}
//                         </Link>
//                       </>
//                     ) : (
//                       <>
//                         <Link
//                           style={{
//                             textDecoration: "underline",
//                             // color: "blue",
//                             fontWeight: "bolder",
//                           }}
//                           to={`/dashboard/FailedGraph/FailedGraphReports`}
//                           onClick={() => {
//                             localStorage.setItem(
//                               "dailyCode",
//                               `${cell.row.original.Date}`
//                             );
//                           }}
//                         >
//                           {cell?.row?.original?.Date}
//                         </Link>
//                       </>
//                     )}
//                   </>
//                 );
//               },
//             });
//           }
//           else if (result.data.messageStatusTables[i].columnName == "Download detail report") {
           
//            await temp.push({
//               Header: result.data.messageStatusTables[i].columnName,
//               accessor: result.data.messageStatusTables[i].columnName,
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.Download == null ? (
//                       <>
//                         <div className="">
//                           <button
//                             type="button"
//                             className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
//                             id="btn_Update"
//                             style={{ width: "auto" }}
//                             onClick={() => {
//                               DownloadAction(cell);
//                             }}
//                             // disabled={DownloadDisable}
//                           >
//                             {/* Download Request */}
//                             <DownloadingSharpIcon />
//                           </button>
//                         </div>
//                       </>
//                     ) : cell.row.original.Download === "" ? (
//                       <>
//                         <Box
//                           sx={{ display: "block", width: "100px" }}
//                           className="mx-auto"
//                         >
//                           <CircularProgress style={{ width: "31px", height: "31px" }} />
//                         </Box>
//                       </>
//                     ) : (
//                       <>
//                         <div className="">
//                           <button
//                             className="btn color_1 px-2"
//                             type="button"
//                             id=""
//                             data-bs-toggle=""
//                             aria-expanded="false"
//                             onClick={() => {
//                               downloadFile(cell);
//                             }}
//                           >
//                             <FileDownloadIcon />
//                           </button>
//                         </div>
//                       </>
//                     )}
//                   </>
//                 );
//               },
//             });
//           }

        
//           else {
//             temp.push({
//               Header: result.data.messageStatusTables[i].columnName,
//               accessor: result.data.messageStatusTables[i].columnName,
//             });
//           }
//         }
//         // temp.splice(1, 1);
//         // temp.push(downloadColumn);
//         // console.log("temp--", temp);
//         // const indexToRemove = temp.length - 2;
//         // if (indexToRemove >= 0) {
//         //   temp.splice(indexToRemove, 1);
//         // }
//         setColumns(temp);

//         // await setHeaderColumn1(result.data.fileUploads);
//       } else {
//         setOpen(false);
//         setHeaderColumn([]);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusdescription,
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//       });
//     }
//   }
//   useEffect(() => {
//     let dynamicColumns = [...columns];
//     let Sno = {
//       Header: "Id",
//       accessor: "id",
//       Cell: (cell) => {
//         // console.log(
//         //   "cell--==",
//         //   cell.row.index + 1,
//         //   cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize
//         // );
//         return (
//           <>
//             {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
//           </>
//         );
//       },
//     };
//     dynamicColumns[0] = Sno;
//     setColumns(dynamicColumns);
//   }, [TableStatus.pageNo, TableStatus.pageSize]);

//   // useEffect(()=>{
//   //   let temp=[]
//   //   for(let i=0;i<columns.length;i++){
//   //     if(columns[i].Header==serialNo.Header){
//   //       temp.push(serialNo)
//   //     }
//   //     else{
//   //       temp.push(columns[i])
//   //     }
//   //   }
//   //   setColumns(temp)
//   // },[TableStatus.pageNo, TableStatus.pageSize,serialNo])

//   // ..................................Post Api.......................................................//

//   async function TableDataGet() {
//     setData([]);
//     setOpen1(true);

//     try {
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/table/data`,
//         // {
//         //   status: value[1] == "successM" ? 3 : 2,
//         // }

//         {
//           pageNo: TableStatus?.pageNo,
//           pageSize: TableStatus?.pageSize,
//           dashBoardRequest: {
//             reportType:
//               value[1] == "successM" ? "Success Message" : "Failed Message",

//             startDate: resd?.timeSeries2?.start,
//             endDate: resd?.timeSeries2?.end,
//           },
//         }
//       );
//       if (result.data.statusDescription.statusCode == 200) {
//         setData(result.data.succesOrFailedMessageTableDatas.content);
//         setData1(result.data.succesOrFailedMessageTableDatas);
//         setOpen1(false);
//       }
//       else if (result.data.statusDescription.statusCode == 220){
//         setOpen1(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//         });
//       } else {
//         setOpen1(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusdescription,
//         });
//       }
//     } catch (error) {
//       setOpen1(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//       });
//     }
//   }
//   async function TableDataGet1() {
//     setData([]);
//     setOpen(true);

//     try {
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/table/data`,
//         // {
//         //   status: value[1] == "successM" ? 3 : 2,
//         // }

//         {
//           pageNo: TableStatus?.pageNo,
//           pageSize: TableStatus?.pageSize,
//           dashBoardRequest: {
//             reportType:
//               value[1] == "successM" ? "Success Message" : "Failed Message",

//             startDate: resd?.timeSeries2?.start,
//             endDate: resd?.timeSeries2?.end,
//           },
//         }
//       );
//       if (result.data.statusDescription.statusCode == 200) {
//         setData(result.data.succesOrFailedMessageTableDatas.content);
//         setData1(result.data.succesOrFailedMessageTableDatas);
//         setOpen(false);
//       } else if (result.data.statusDescription.statusCode == 220){
//         setOpen1(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusdescription,
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//       });
//     }
//   }

//   useEffect(() => {
//     if (byDefaultTableApiNotHit == true) {
//       TableDataGet();
//     }
//   }, [
//     TableStatus.pageNo,
//     TableStatus.pageSize,
//     // resd?.timeSeries2?.start,
//     // resd?.timeSeries2?.end,
//   ]);
//   // ......................................Loader API.........................................................//

//   async function TableLoader() {
//     try {
//       if (TodayGraphApiNotHit == true) {
//         const result = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/table/data`,
//           // {
//           //   status: value[1] == "successM" ? 3 : 2,
//           // }
//           {
//             pageNo: TableStatus?.pageNo,
//             pageSize: TableStatus?.pageSize,
//             dashBoardRequest: {
//               reportType:
//                 value[1] == "successM" ? "Success Message" : "Failed Message",

//               startDate: resd?.timeSeries2?.start,
//               endDate: resd?.timeSeries2?.end,
//             },
//           }
//         );
//         if (result.data.statusDescription.statusCode == 200) {
//           setData(result.data.succesOrFailedMessageTableDatas.content);
//           setData1(result.data.succesOrFailedMessageTableDatas);
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: result.data.statusDescription.statusdescription,
//           });
//         }
//       } else {
//         const result = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/today-yesterday/message/data`,
//           // {
//           //   status: value[1] == "successM" ? 3 : 2,
//           // }

//           {
//             pageNo: TableStatus?.pageNo,
//             pageSize: TableStatus?.pageSize,
//             dashBoardRequest: {
//               reportType:
//                 value[1] == "successM" ? "Today Success" : "Today Failed",
//               dailyCode:
//                 Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
//             },
//           }
//         );
//         if (result.data.statusDescription.statusCode == 200) {
//           setData(result.data.succesOrFailedMessageTableDatas.content);
//           setData1(result.data.succesOrFailedMessageTableDatas);
//           setOpen1(false);
//         } else {
//           setOpen1(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: result.data.statusDescription.statusdescription,
//           });
//         }
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//       });
//     }
//   }
//   // ..................................................................................................//
//   // const currentMonth = moment().format("MM");
//   // const currentYear = moment().format("YYYY");

//   useEffect(() => {
//     return () => {
//       dispatch(setTimeSeries2(JSON.parse(localStorage.getItem("TimeSeries2"))));
//     };
//   }, []);

//   // .................Refresh Btn Api.....................................................................................//

//   async function RefreshBtn() {
//     setData([]);
//     setOpen1(true);

//     try {
//       if (TodayGraphApiNotHit == true) {
//         const result = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/table/data`,
//           // {
//           //   status: value[1] == "successM" ? 3 : 2,
//           // }

//           {
//             pageNo: TableStatus?.pageNo,
//             pageSize: TableStatus?.pageSize,
//             dashBoardRequest: {
//               reportType:
//                 value[1] == "successM" ? "Success Message" : "Failed Message",

//               startDate: resd?.timeSeries2?.start,
//               endDate: resd?.timeSeries2?.end,
//             },
//           }
//         );
//         if (result.data.statusDescription.statusCode == 200) {
//           setData(result.data.succesOrFailedMessageTableDatas.content);
//           setData1(result.data.succesOrFailedMessageTableDatas);
//           setOpen1(false);
//         }  else if (result.data.statusDescription.statusCode == 220){
//           setOpen1(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: result.data.statusDescription.statusMessage,
//           });
//         }else {
//           setOpen1(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: result.data.statusDescription.statusdescription,
//           });
//         }
//       } else {
//         const result = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/today-yesterday/message/data`,
//           // {
//           //   status: value[1] == "successM" ? 3 : 2,
//           // }

//           {
//             pageNo: TableStatus?.pageNo,
//             pageSize: TableStatus?.pageSize,
//             dashBoardRequest: {
//               reportType:
//                 value[1] == "successM" ? "Today Success" : "Today Failed",
//               dailyCode:
//                 Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
//             },
//           }
//         );
//         if (result.data.statusDescription.statusCode == 200) {
//           setData(result.data.succesOrFailedMessageTableDatas.content);
//           setData1(result.data.succesOrFailedMessageTableDatas);
//           setOpen1(false);
//         } else {
//           setOpen1(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: result.data.statusDescription.statusdescription,
//           });
//         }
//       }
//     } catch (error) {
//       setOpen1(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//       });
//     }
//   }

//   // .......................................................................................................................//

//   const [downloadModelOpen, setDownloadModel] = useState(undefined);
//   const [tableLoaderIndex, setTableLoaderIndex] = useState();
//   // console.log("date--", downloadModelOpen);

//   const modelButtonDownload = useRef(null);
//   const DownloadAction = async (cell) => {
//     // console.log("date11--", date);
//     setDownloadModel(cell.row.original);
//     // setTableLoaderIndex(index);
//     await modelButtonDownload.current.click();
//   };

//   async function DownloadActionget() {
//     try {
//       if (TodayGraphApiNotHit == true ) {
//         const result = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/download/current-month/succes-failed/message/report`,
//           // "http://192.168.167.66:5002/v1/get-all/file",
//           {
//             downloadReportRequest: {
//               // reportType:"Success Message",
//               reportType:
//                 value[1] == "successM" ? "Success Message" : "Failed Message",
//               dailyCode: downloadModelOpen.Date,
//               pstatus: value[1] == "successM" ? 3 : 2,
//             },
//           }
//         );
//         if (result.data.statusDescription.statusCode == 200) {
//           TableLoader();
//         } else {
//           // setTableLoader(false);
//           // setOpen(false);

//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: result.data.statusDescription.statusMessage,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//           // console.log(result.data.statusMessage);
//         }
//       } else {
//         const result = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/download/today-yesterday/succes-failed/message/report`,

//           // "http://192.168.167.66:5002/v1/get-all/file",
//           {
//             downloadReportRequest: {
//               reportType:
//                 value[1] == "successM" ? "Today Success" : "Today Failed",
//               dailyCode: downloadModelOpen.Date,
//               pstatus: value[1] == "successM" ? 3 : 2,
//               startDate: `${resd?.timeSeries2?.start} ${downloadModelOpen.Hour}:00:00`,
//               endDate: `${resd?.timeSeries2?.end} ${downloadModelOpen.Hour}:59:59`,
//               hourCode: downloadModelOpen.Hour,
//             },
//           }
//         );
//         if (result.data.statusDescription.statusCode == 200) {
//           TableLoader();
//         } else {
//           // setTableLoader(false);
//           // setOpen(false);

//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: result.data.statusDescription.statusMessage,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//           // console.log(result.data.statusMessage);
//         }
//       }
//     } catch (error) {
//       // setOpen(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   }

//   const headers = [
//     "daily_Code",
//     "delivered",
//     "message_Sent",
//     "successfully_Submited",
//   ];
//   const dataa = [
//     {
//       delivered: 0,
//       daily_Code: "2023-07-18",
//       message_Sent: 0,
//       successfully_Submited: 10,
//     },
//     {
//       delivered: 0,
//       daily_Code: "2023-07-18",
//       message_Sent: 0,
//       successfully_Submited: 20,
//     },
//     {
//       delivered: 0,
//       daily_Code: "2023-07-19",
//       message_Sent: 10,
//       successfully_Submited: 40,
//     },
//   ];

//   //   const downloadFile = (cell) => {
//   //   // console.log("hlooooooo");
//   //   // alert("hii");
//   //   window.location.href = cell.row.original.Download; //to download the file from url in download button
//   // };

//   const downloadFile = async (cell) => {
//     //  console.log(cell.row.original.Download,"kkjhh")
//     try {
//       const response = await common_axios.get(
//         `${cell?.row?.original?.Download}`,
//         {
//           responseType: "blob",
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             UserId: `${localStorage.getItem("UserId")}`,
//             Source: "web",
//           },
//         }
//       );

//       const url = window.URL.createObjectURL(
//         new Blob([response.data], { type: "application/vnd.ms-excel" })
//       );
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `excel-file.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//     } catch (error) {
//       // console.error(error);
//     }
//   };

//   // .....................................Today Tab APIs............................................................//

//   const TodayGraphApi = async (e) => {
//     var date = moment(resd?.timeSeries?.end);
//     var now = moment(resd?.timeSeries?.start);
//     var duration = moment.duration(date.diff(now));
//     var noofDays = duration.asDays();
//     if (value[1] == "successM") {
//       setDataGraph([]);
//       // alert("lkj")
//       try {
//         setOpen(true);
//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/table/today-yesterday/graph`,
//           {
//             dashBoardRequest: {
//               // dailyCode: resd?.timeSeries2?.start,
//               dailyCode:
//                 Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
//               // startDate: "2023-08-01",
//               // endDate: "2023-08-31",
//               flag: "Success",
//             },
//           }
//         );
//         if (res.data?.statusDescription?.statusCode == 200) {
//           // setData1(res.data);
//           // TableDataGet1();
//           setOpen(false);
//           setRowData(res.data?.dataSets);
//           setLabelDate(res.data.xaxixLabelHour);
//           // localStorage.removeItem("dashboardTopTabs")
//           if (res.data?.dataSets?.length == 0) {
//             setDataGraph([]);
//           } else {
//             res.data["dataSets1"] = [];
//             let varrr = false;
//             for (let index = 0; index < res.data?.dataSets.length; index++) {
//               res.data.dataSets[index]["pointRadius"] = 0;
//               res.data.dataSets[index]["clicked"] = true;

//               if (res.data.dataSets[index].label == "Pushed To SMSC") {
//                 res.data.dataSets[index]["backgroundColor"] = "#f9442f";
//                 res.data.dataSets[index]["borderColor"] = "#f9442f";
//                 res.data.dataSets[index]["icon"] = StopCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;
//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#f9442f";
//               }

//               if (res.data.dataSets[index].label == "Delivered") {
//                 res.data.dataSets[index]["backgroundColor"] = "#5ab778";
//                 res.data.dataSets[index]["borderColor"] = "#5ab778";
//                 res.data.dataSets[index]["icon"] = CheckCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;

//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#5ab778";
//               }
//               for (
//                 let i = 0;
//                 i < res.data?.dataSets[index]?.data?.length;
//                 i++
//               ) {
//                 if (res.data?.dataSets[index]?.data[i] != 0) {
//                   varrr = true;
//                 }
//               }
//             }
//             if (!varrr) {
//               setDataGraph([]);
//             } else {
//               if (value[1] == "successM") {
//                 setDataGraph({
//                   labels: res.data?.xaxixLabelHour,
//                   labelsName: res.data?.xaxixLabelHour,
//                   labelsNumber: res.data?.xaxisLabels,
//                   datasets: res.data?.dataSets1,

//                   // datasets: [
//                   //   {
//                   //     label: "Pending for Approval",
//                   //     data: [65, 29, 80, 31, 56, 39, 41, 65, 22, 89, 81],
//                   //     borderColor: "#39CCCC",
//                   //     // backgroundColor: "rgb(0,0,135)",
//                   //     backgroundColor: "#39CCCC",
//                   //     yAxisID: "y",
//                   //     tension: 0.5,
//                   //   },
//                   //   {
//                   //     label: "Active",
//                   //     data: [76, 29, 92, 61, 60, 52, 46, 87, 59, 90, 81],
//                   //     borderColor: "#D81B60",
//                   //     // backgroundColor: "rgb(117,217,239)",
//                   //     backgroundColor: "#D81B60",
//                   //     yAxisID: "y1",
//                   //     tension: 0.5,
//                   //   },
//                   //   {
//                   //     label: "In Process",
//                   //     data: [50, 17, 60, 44, 26, 14, 29, 15, 59, 89, 51],
//                   //     borderColor: "#FF851B",
//                   //     // backgroundColor: "rgb(80,108,120)",
//                   //     backgroundColor: "#FF851B",
//                   //     yAxisID: "y1",
//                   //     tension: 0.5,
//                   //   },
//                   //   {
//                   //     label: "Rejected",
//                   //     data: [10, 9, 37, 41, 21, 28, 11, 35, 24, 67, 61],
//                   //     borderColor: "#605CA8)",
//                   //     // backgroundColor: "rgb(216,217,221)",
//                   //     backgroundColor: "#605CA8",
//                   //     yAxisID: "y1",
//                   //     tension: 0.5,
//                   //   },
//                   // ],
//                 });
//               }
//             }
//           }
//           // setOpen(false);
//         } else {
//           setDataGraph([]);
//           setOpen(false);
//         }
//       } catch (error) {
//         setDataGraph([]);
//         setOpen(false);
//         // console.log(error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } else {
//       setDataGraph([]);

//       try {
//         setOpen(true);
//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/table/today-yesterday/graph`,
//           {
//             dashBoardRequest: {
//               // startDate: "2023-08-01",
//               // endDate: "2023-08-31",
//               dailyCode:
//                 Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
//               flag: "Failed",
//             },
//           }
//         );

//         if (res.data?.statusDescription.statusCode == 200) {
//           // TableDataGet1();

//           setRowData(res.data?.dataSets);
//           setLabelDate(res.data.xaxixLabelHour);
//           setOpen(false);
//           // localStorage.removeItem("dashboardTopTabs")
//           if (res.data?.dataSets?.length == 0) {
//             setDataGraph([]);
//             setOpen(false);
//           } else {
//             let varrr = false;
//             res.data["dataSets1"] = [];
//             for (let index = 0; index < res.data?.dataSets?.length; index++) {
//               res.data.dataSets[index]["pointRadius"] = 0;
//               res.data.dataSets[index]["clicked"] = true;

//               if (res.data.dataSets[index].label == "Dnd") {
//                 res.data.dataSets[index]["backgroundColor"] = "#536878";
//                 res.data.dataSets[index]["borderColor"] = "#536878";
//                 res.data.dataSets[index]["icon"] = BlockIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;

//                 res.data.dataSets[index]["pointHoverRadius"] = 6;
//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#536878";
//               }
//               if (res.data.dataSets[index].label == "Blacklist") {
//                 res.data.dataSets[index]["backgroundColor"] = "#221133";
//                 res.data.dataSets[index]["borderColor"] = "#221133";
//                 res.data.dataSets[index]["icon"] = CancelIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;
//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#221133";
//               }
//               if (res.data.dataSets[index].label == "Nack") {
//                 res.data.dataSets[index]["backgroundColor"] = "#a40000";
//                 res.data.dataSets[index]["borderColor"] = "#a40000";
//                 res.data.dataSets[index]["icon"] = CheckCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;

//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#a40000";
//               }


//               if (res.data.dataSets[index].label == "System Error") {
//                 res.data.dataSets[index]["backgroundColor"] = "#f9442f";
//                 res.data.dataSets[index]["borderColor"] = "#f9442f";
//                 res.data.dataSets[index]["icon"] =
//                   SystemSecurityUpdateWarningIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;

//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "#f9442f";
//               }
//               if (res.data.dataSets[index].label == "Message Sent") {
//                 res.data.dataSets[index]["backgroundColor"] = "#f9442f";
//                 res.data.dataSets[index]["borderColor"] = "#f9442f";
//                 res.data.dataSets[index]["icon"] = StopCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//               }
//               if (res.data.dataSets[index].label == "Waiting For ACK") {
//                 res.data.dataSets[index]["backgroundColor"] = "orange";
//                 res.data.dataSets[index]["borderColor"] = "orange";
//                 res.data.dataSets[index]["icon"] = CheckCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//                 res.data.dataSets[index]["pointStyle"] = "circle";
//                 res.data.dataSets[index]["pointRadius"] = 4;
//                 res.data.dataSets[index]["pointHoverRadius"] = 6;
//                 res.data.dataSets[index]["pointBackgroundColor"] = "white";
//                 res.data.dataSets[index]["pointBorderColor"] = "orange";
//               }
//               if (res.data.dataSets[index].label == "Delivered") {
//                 res.data.dataSets[index]["backgroundColor"] = "#5ab778";
//                 res.data.dataSets[index]["borderColor"] = "#5ab778";
//                 res.data.dataSets[index]["icon"] = CheckCircleIcon;
//                 res.data["dataSets1"].push(res.data.dataSets[index]);
//               }
//               for (
//                 let i = 0;
//                 i < res.data?.dataSets[index]?.data?.length;
//                 i++
//               ) {
//                 if (res.data?.dataSets[index]?.data[i] != 0) {
//                   varrr = true;
//                 }
//               }
//             }
//             if (!varrr) {
//               setDataGraph([]);
//             } else {
//               if (value[1] != "successM") {
//                 setDataGraph({
//                   labels: res.data?.xaxixLabelHour,

//                   datasets: res.data?.dataSets1,
//                 });
//               }
//             }
//           }
//           // setOpen(false);
//         } else {
//           setDataGraph([]);
//           setOpen(false);
//         }
//       } catch (error) {
//         // console.error({ error });

//         setDataGraph([]);

//         setOpen(false);
//         // console.log(error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     }
//   };

//   // ..............................................................................................................//
//   async function TodayTableget() {
//     // setData([]);
//     let temp = [];
//     let Sno = {
//       Header: "Id",
//       accessor: "id",
//       Cell: (cell) => {
//         // console.log(
//         //   "cell--==",
//         //   cell.row.index + 1,
//         //   cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize
//         // );
//         return (
//           <>
//             {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
//           </>
//         );
//       },
//     };
//     setSerialNo(Sno);
//     // let dateColumn = {

//     //     Header: "Date",

//     //     accessor: "Date",
//     //     Cell: (cell) => {
//     //       return (
//     //         <>
//     //           <Link

//     //             style={{
//     //               textDecoration: "underline",
//     //               // color: "blue",
//     //               fontWeight: "bolder",
//     //             }}
//     //             to={`/dashboard/TransactionalReport/All`}
//     //           >
//     //             {cell?.row?.original?.Date}
//     //           </Link>

//     //         </>
//     //       );

//     //   },
//     // }
//     let downloadColumn = {
//       Header: "Download",
//       accessor: "download",
//       // Cell: ({ row }) => (
//       //   <button>Download</button>
//       // ),
//       Cell: (cell) => {
//         return (
//           <>
//             {cell.row.original.Download == null ? (
//               <>
//                 <div className="">
//                   <button
//                     type="button"
//                     className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
//                     id="btn_Update"
//                     style={{ width: "auto" }}
//                     onClick={() => {
//                       DownloadAction(cell);
//                     }}
//                     // disabled={DownloadDisable}
//                   >
//                     {/* Download Request */}
//                     <DownloadingSharpIcon />
                    
//                   </button>
//                 </div>
//               </>
//             ) : cell.row.original.Download === "" ? (
//               <>
//                 <Box
//                   sx={{ display: "block", width: "100px" }}
//                   className="mx-auto"
//                 >
//                   <CircularProgress style={{ width: "31px", height: "31px" }} />
//                 </Box>
//               </>
//             ) : (
//               <>
//                 <div className="">
//                   <button
//                     className="btn color_1 px-2"
//                     type="button"
//                     id=""
//                     data-bs-toggle=""
//                     aria-expanded="false"
//                     onClick={() => {
//                       downloadFile(cell);
//                     }}
//                   >
//                     <FileDownloadIcon />
//                   </button>
//                 </div>
//               </>
//             )}
//           </>
//         );
//       },
//     };
//     try {
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/today-yesterday/message/status`,
//         {
//           p_status: value[1] == "successM" ? [3, 4] : [2, 4],
//         }
//       );
//       if (result.data.statusDescription.statusCode == 200) {
//         await setHeaderColumn(result.data.messageStatusTables);
//         temp.push(Sno);
//         // temp.push(dateColumn);
//         for (let i = 0; i < result.data.messageStatusTables.length; i++) {
//           if (result.data.messageStatusTables[i].columnName == "Hour") {
//             temp.push({
//               Header: result.data.messageStatusTables[i].columnName,
//               accessor: result.data.messageStatusTables[i].columnName,
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {value[1] == "successM" ? (
//                       <>
//                         <Link
//                           style={{
//                             textDecoration: "underline",
//                             // color: "blue",
//                             fontWeight: "bolder",
//                           }}
//                           to={`/dashboard/SuccessGraph/SuccessGraphReports`}
//                           onClick={() => {
//                             localStorage.setItem(
//                               "dailyCode",
//                               `${cell.row.original.Hour}`
//                             );
//                           }}
//                         >
//                           {cell?.row?.original?.Hour}
//                         </Link>
//                       </>
//                     ) : (
//                       <>
//                         <Link
//                           style={{
//                             textDecoration: "underline",
//                             // color: "blue",
//                             fontWeight: "bolder",
//                           }}
//                           to={`/dashboard/FailedGraph/FailedGraphReports`}
//                           onClick={() => {
//                             localStorage.setItem(
//                               "dailyCode",
//                               `${cell.row.original.Hour}`
//                             );
//                           }}
//                         >
//                           {cell?.row?.original?.Hour}
//                         </Link>
                        
//                       </>
//                     )}
//                   </>
//                 );
//               },
//             });
//           } else if (result.data.messageStatusTables[i].columnName == "S.No") {
//           } else if (
//             result.data.messageStatusTables[i].columnName == "Download detail report"
//           ) {
//             temp.push({
//               Header: result.data.messageStatusTables[i].columnName,
//               accessor: result.data.messageStatusTables[i].columnName,
//               Cell: (cell) => {
//                 return (
//                   <>
//                     {cell.row.original.Download == null ? (
//                       <>
//                         <div className="">
//                           <button
//                             type="button"
//                             className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
//                             id="btn_Update"
//                             style={{ width: "auto" }}
//                             onClick={() => {
//                               DownloadAction(cell);
//                             }}
//                             // disabled={DownloadDisable}
//                           >
//                             <DownloadingSharpIcon />
//                           </button>
//                         </div>
//                       </>
//                     ) : cell.row.original.Download === "" ? (
//                       <>
//                         <Box
//                           sx={{ display: "block", width: "100px" }}
//                           className="mx-auto"
//                         >
//                           <CircularProgress
//                             style={{ width: "31px", height: "31px" }}
//                           />
//                         </Box>
//                       </>
//                     ) : (
//                       <>
//                         <div className="">
//                           <button
//                             className="btn color_1 px-2"
//                             type="button"
//                             id=""
//                             data-bs-toggle=""
//                             aria-expanded="false"
//                             onClick={() => {
//                               downloadFile(cell);
//                             }}
//                           >
//                             <FileDownloadIcon />
//                           </button>
//                         </div>
//                       </>
//                     )}
//                   </>
//                 );
//               },
//             });
//           } else {
//             temp.push({
//               Header: result.data.messageStatusTables[i].columnName,
//               accessor: result.data.messageStatusTables[i].columnName,
//             });
//           }
//         }
//         // temp.splice(1, 1);
//         // temp.push(downloadColumn);
//         // console.log("temp--", temp);
//         // const indexToRemove = temp.length - 2;
//         // if (indexToRemove >= 0) {
//         //   temp.splice(indexToRemove, 1);
//         // }
//         setColumns(temp);

//         // await setHeaderColumn1(result.data.fileUploads);
//       } else {
//         setOpen(false);
//         setHeaderColumn([]);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusdescription,
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//       });
//     }
//   }
//   useEffect(() => {
//     let dynamicColumns = [...columns];
//     let Sno = {
//       Header: "Id",
//       accessor: "id",
//       Cell: (cell) => {
//         // console.log(
//         //   "cell--==",
//         //   cell.row.index + 1,
//         //   cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize
//         // );
//         return (
//           <>
//             {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
//           </>
//         );
//       },
//     };
//     dynamicColumns[0] = Sno;
//     setColumns(dynamicColumns);
//   }, [TableStatus.pageNo, TableStatus.pageSize]);

//   useEffect(() => {
//     if ((Tabs == "3" || Tabs == "4") && TodayGraphApiNotHit == false) {
//       TodayTableget();

//     } else {
//       Tableget();
//     }
//   }, [Status?.dateTabs0]);
//  useEffect(()=>{
// setAnchorEll(false)
//  },[resd?.timeSeries2?.buttonClicked])
//   // ..........................................................................................//

//   async function TodayTableDataGet() {
//     setData([]);
//     setOpen1(true);

//     try {
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/today-yesterday/message/data`,
//         // {
//         //   status: value[1] == "successM" ? 3 : 2,
//         // }
//         {
//           pageNo: TableStatus?.pageNo,
//           pageSize: TableStatus?.pageSize,
//           dashBoardRequest: {
//             reportType:
//               value[1] == "successM" ? "Today Success" : "Today Failed",
//             // dailyCode: resd?.timeSeries2?.start,
//             dailyCode:
//               Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
//           },
//         }
//       );
//       if (result.data.statusDescription.statusCode == 200) {
//         setData(result.data.succesOrFailedMessageTableDatas.content);
//         setData1(result.data.succesOrFailedMessageTableDatas);
//         setOpen1(false);
//       } 
//       else if (result.data.statusDescription.statusCode == 220){
//         setOpen1(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//         });
//       }
//       else {
//         setOpen1(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusdescription,
//         });
//       }
//     } catch (error) {
//       setOpen1(false);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//       });
//     }
//   }
//   const [ViewTableForm, setViewTableForm] = React.useState(false);
//   const [anchorEl4, setAnchorEl4] = React.useState(null);
//   const openmenue4 = Boolean(anchorEl4);
//   const downloadRef_revenuecost = useRef(null);
//   const downloadRef_revenuecost_graph = useRef(null);

//   const [isFullScreen, setFullScreen] = useState(false);
//    console.log("dh8", isFullScreen);
//   const downloadRef_revenuecost_child = useRef(null);
//   const [RevenueCostData, setRevenueCostData] = useState(null);
//   const handleClosemenue4 = () => {
//     setAnchorEl4(null);
//   };
//   const handleClickmenue4 = (event) => {
//     setAnchorEl4(event.currentTarget);
//   };
//   // const handleClosemenue = () => {
//   //   setAnchorEl(null);
//   // };

//   const enterFullScreen = () => {
//     handleClosemenue4();
//     // setgloblecancel(true)
//     setFullScreen(true)
//     const element = document.getElementById("revenucostgraphFull");
//     if (element) {
//       if (element.requestFullscreen) {
//         element
//           .requestFullscreen()
//           .then(() => setFullScreen(true))
//           .catch((error) => console.log("Error entering full-screen:", error));
//       } else if (element.webkitRequestFullscreen) {
//         // Safari
//         element
//           .webkitRequestFullscreen()
//           .then(() => setFullScreen(true))
//           .catch((error) => console.log("Error entering full-screen:", error));
//       } else if (element.msRequestFullscreen) {
//         // Internet Explorer
//         element
//           .msRequestFullscreen()
//           .then(() => setFullScreen(true))
//           .catch((error) => console.log("Error entering full-screen:", error));
//       } else {
//         setFullScreen(false);
//       }
//     }
//   };

//   const downloadChartAsPDF_revenucostDATA = async () => {
//     handleClosemenue4();
//     // const element = downloadRef_revenuecost.current;
//     // html2canvas(element, { scale: 2 }).then((canvas) => {
//     //   const imgData = canvas.toDataURL("image/png");
//     //   const pdf = new jsPDF("p", "mm", "a4");
//     //   const pdfWidth = 190;
//     //   const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
//     //   pdf.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight);
//     //   if (value[1] == "successM") {
//     //     pdf.save("SuccessGraph.pdf");
//     //   } else {
//     //     pdf.save("FailedGraph.pdf");
//     //   }
//     // });

//     const canvas1 = await html2canvas(downloadRef_revenuecost_graph.current, { scale: 2 });
//     const imgData1 = canvas1.toDataURL("image/png");
//     // const pdf = new jsPDF("p", "mm", "a4");
//     const pdf = new jsPDF("p", "pt", [320, 500]);
//     const pdfWidth = 270;
//     const pdfHeight1 = (canvas1.height * pdfWidth) / canvas1.width;
//     pdf.addImage(imgData1, "PNG", 20, 20, pdfWidth, pdfHeight1);
//     // pdf.addImage(imgData1, "PNG", 10, 10);
  
//     // Add a page for section 2
//     pdf.addPage();
  
//     // Capture section 2
//     const canvas2 = await html2canvas(downloadRef_revenuecost.current, { scale: 2 });
//     const imgData2 = canvas2.toDataURL("image/png");

//     const pdfHeight2 = (canvas2.height * pdfWidth) / canvas2.width;
//     pdf.addImage(imgData2, "PNG", 20, 20, pdfWidth, pdfHeight2);
//     // pdf.addImage(imgData2, "PNG", 10, 10);
//     // Save the PDF
//     // pdf.save("combined_sections.pdf");
//     if (value[1] == "successM") {
//           pdf.save("SuccessGraph.pdf");
//         } else {
//           pdf.save("FailedGraph.pdf");
//         }

//   };
//   const downloadChartAsimage_revenucostDATA = async () => {
//     const element = downloadRef_revenuecost_graph.current;
//     html2canvas(element, { scale: 2 }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const link = document.createElement('a');
//       link.href = imgData;
//       link.download = 'Image.png';
//       // if (value[1] == "successM") {
//       //   link.download("SuccessGraphImage.png");
//       // } else {
//       //   link.download("FailedGraphImage.png");
//       // }
//       link.click();
//     });
//   };

//   // Capture section 1

  
//   const downloadChartAsPDF_revenucostDATA_forTable = async () => {
//     //  for img
//     setOpen(true);
//     handleClosemenue4();
//     const element = downloadRef_revenuecost_child.current;

//     html2canvas(element, { scale: 2 }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "pt", [320, 500]);
//       const pdfWidth = 300;
//       const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
//       if (pdf) {
//         setOpen(false);
//       }
//       pdf.addImage(imgData, "PNG", 20, 20, pdfWidth, pdfHeight);
//       pdf.save("Revenue & Cost.pdf");
//     });
//   };

//   const exitFullScreen = () => {
//     handleClosemenue4();
//     if (document.exitFullscreen) {
//       document
//         .exitFullscreen()
//         .then(() => setFullScreen(false))
//         .catch((error) => console.log("Error exiting full-screen:", error));
//     } else if (document.webkitExitFullscreen) {
//       // Safari
//       document
//         .webkitExitFullscreen()
//         .then(() => setFullScreen(false))
//         .catch((error) => console.log("Error exiting full-screen:", error));
//     } else if (document.msExitFullscreen) {
//       // Internet Explorer
//       document
//         .msExitFullscreen()
//         .then(() => setFullScreen(false))
//         .catch((error) => console.log("Error exiting full-screen:", error));
//     } else {
//       setFullScreen(false);
//     }
//   };

//   const handleClickExcel_revenucostDATA = () => {
//     // Create workbook and worksheet
//     handleClosemenue4();

//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.json_to_sheet([]);

//     // Set headers
//     const headers = [
//       "Date",
//       ...dataGraph.datasets.map((series) => series.label),
//     ];
//     XLSX.utils.sheet_add_json(worksheet, [headers], { skipHeader: true });

//     // Set data
//     const rows = dataGraph.labels.map((xAxis, index) => {
//       const rowData = [
//         xAxis,
//         ...dataGraph.datasets.map((series) => series.data[index]),
//       ];
//       return rowData;
//     });
//     XLSX.utils.sheet_add_json(worksheet, rows, {
//       skipHeader: true,
//       origin: "A2",
//     });

//     // Add the worksheet to the workbook
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

//     // Generate the Excel file
//     if (value[1] == "successM") {
//       XLSX.writeFile(workbook, "SuccessGraph.xlsx");
//     } else {
//       XLSX.writeFile(workbook, "FailedGraph.xlsx");
//     }
//   };
//   useEffect(() => {
//     window.addEventListener("resize", function () {
//       if (window.innerHeight >= window.screen.height - 20) {
//         console.log("The browser is in fullscreen mode");
//         if (globlecancel) {
//           setFullScreen(true);
//         }
//       } else {
//         console.log("The browser is NOT in fullscreen mode");
//         setFullScreen(false);
//         setgloblecancel(false);
//       }

//       // console.log('her')
//     });
//   }, []); 
//   return (
//     <>
//       <Backdrop
//         sx={{
//           transform: "translateZ(0)",
//           color: "#fff",
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//         // open={open1}
//         open={open}

//         // onClick={handleClose}
//       >
//         <Loader />
//       </Backdrop>
//       <div>
//         <button
//           // ref={modelButtonApprove}
//           ref={modelButtonDownload}
//           type="button"
//           className="btn btn-primary d-none"
//           data-bs-toggle="modal"
//           data-bs-target="#staticBackdrop2"
//         >
//           Launch static backdrop modal
//         </button>

//         <div
//           className="modal fade"
//           id="staticBackdrop2"
//           data-bs-backdrop="static"
//           data-bs-keyboard="false"
//           tabindex="-1"
//           aria-labelledby="staticBackdrop2Label"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog ">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title" id="staticBackdrop2Label">
//                   Download Request
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 ></button>
//               </div>

//               <div className="modal-body">
//                 {/* Are you sure you want to download the report ? */}
//                 Are you sure you want to initiate the download request ?
//               </div>

//               <div className="modal-footer justify-content-between">
//                 <button
//                   type="button"
//                   className="btn btn-secondary shadow"
//                   data-bs-dismiss="modal"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary editcolor shadow okbtn"
//                   data-bs-dismiss="modal"
//                   // onClick={() => {
//                   //   DownloadButtonApi
//                   // }}
//                   onClick={DownloadActionget}
//                 >
//                   Download Request
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="container-fluid py-3">
//         <div className="card" id="canvas_card">
//           <div className="card-header p-3 pt-2">
//             <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
//               <PersonIcon
//                 style={{
//                   color: "white",
//                   fontSize: "27px",
//                 }}
//               />
//             </div>
//             <div
//               className="d-flex justify-content-between align-items-center"
//               style={{ marginLeft: "6rem" }}
//             >
//               {/* <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
//                Success Graph
//               </p> */}

//               <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
//                 {localStorage.getItem("dstQueCode1")?.split(",")?.[1] ==
//                 "campaign"
//                   ? "Campaign Report"
//                   : localStorage.getItem("dstQueCode1")?.split(",")?.[1] ==
//                     "failedM"
//                   ? "Failed Graph"
//                   : "Success Graph"}
//               </p>
//               <div className="d-flex align-items-center">
//                 <div className="my-auto me-4">
//                   <div class="datePickerButtonsDashboard">
//                     {[
//                       // {
//                       //   name: "Yesterday",
//                       //   startdateValue: "",
//                       //   enddateValue: "",
//                       // },
//                       {
//                         name: "1D",
//                         startdateValue: moment().format("YYYY-MM-DD"),
//                         enddateValue: moment().format("YYYY-MM-DD"),
//                         dateTypee: "Daily",
//                         tooltipText: "1 Day",
//                       },

//                       {
//                         name: "1W",
//                         startdateValue: moment(addDays(new Date(), -6)).format(
//                           "YYYY-MM-DD"
//                         ),
//                         enddateValue: moment().format("YYYY-MM-DD"),
//                         dateTypee: "Daily",
//                         tooltipText: "1 Week",
//                       },

//                       {
//                         name: "1M",
//                         enddateValue: moment().format("YYYY-MM-DD"),
//                         startdateValue: moment(addDays(new Date(), -29)).format(
//                           "YYYY-MM-DD"
//                         ),

//                         dateTypee: "Month",
//                         startDateMonth: moment(
//                           startOfMonth(addMonths(new Date(), -1))
//                         ).format("YYYYMM"),
//                         endDateMonth: moment().format("YYYYMM"),
//                         tooltipText: "1 Month",
//                       },
//                       {
//                         name: "3M",
//                         startdateValue: moment(
//                           addMonths(new Date(), -3)
//                         ).format("YYYY-MM-DD"),
//                         enddateValue: moment().format("YYYY-MM-DD"),
//                         dateTypee: "Monthly",
//                         tooltipText: "3 Months",
//                       },

//                       {
//                         name: "6M",
//                         startdateValue: moment(
//                           addMonths(new Date(), -6)
//                         ).format("YYYY-MM-DD"),
//                         enddateValue: moment().format("YYYY-MM-DD"),
//                         dateTypee: "Monthly",
//                         tooltipText: "6 Months",
//                       },
//                     ].map((dataaa, index) => {
//                       return (
//                         <a
//                           data-bs-toggle="tooltip"
//                           data-bs-placement="top"
//                           title={dataaa.tooltipText}
//                           onClick={() => {
                         
//                             // let admission = moment(
//                             //   dataaa?.startdateValue,
//                             //   "YYYY-MM-DD"
//                             // );
//                             // let discharge = moment(
//                             //   dataaa?.enddateValue,
//                             //   "YYYY-MM-DD"
//                             // );
//                             // let admission1 = moment(
//                             //   resd?.timeSeries1?.start,
//                             //   "YYYY-MM-DD"
//                             // );
//                             // let discharge1 = moment(
//                             //   resd?.timeSeries1?.end,
//                             //   "YYYY-MM-DD"
//                             // );

//                             // console.log(
//                             //   discharge.diff(admission, "days"),
//                             //   discharge1.diff(admission1, "days")
//                             // );
//                             dispatch(
//                               setTimeSeries2({
//                                 start: dataaa?.startdateValue,
//                                 end: dataaa?.enddateValue,
//                                 dateType: resd?.timeSeries2?.dateType,
//                                 buttonClicked:
//                                   !resd?.timeSeries2?.buttonClicked,
//                                   dateReset:dataaa.name,
//                               })
//                             );
//                             setTableStatus({
//                               ...TableStatus,
                         
//                               pageNo: 0,
//                               pageSize:10,
//                             });
//                             setStatus({
//                               ...Status,
//                               dateTabs0: dataaa,
//                               pageNo: 0,
//                             });
//                             setPaginationPage(1);
//                             if (dataaa.name == "1D") {
//                               // localStorage.setItem("dashboardTopTabs", "3");
//                               setTodayGraphApiNotHit(false);

//                             } else {
//                               setTodayGraphApiNotHit(true);
//                             }
//                           }}
//                           // className={`${(function () {
//                           //   let admission = moment(
//                           //     dataaa?.startdateValue,
//                           //     "YYYY-MM-DD"
//                           //   );
//                           //   let discharge = moment(
//                           //     dataaa?.enddateValue,
//                           //     "YYYY-MM-DD"
//                           //   );
//                           //   let admission1 = moment(
//                           //     resd?.timeSeries2?.start,
//                           //     "YYYY-MM-DD"
//                           //   );
//                           //   let discharge1 = moment(
//                           //     resd?.timeSeries2?.end,
//                           //     "YYYY-MM-DD"
//                           //   );
//                           //   const val =
//                           //     discharge.diff(admission, "days") ===
//                           //     discharge1.diff(admission1, "days")
//                           //       ? "active"
//                           //       : "";

//                           //   return val;
//                           // })()}`}

//                           className={`${(function () {
//                             let admission = moment(
//                               dataaa?.startdateValue,
//                               "YYYY-MM-DD"
//                             );
//                             let discharge = moment(
//                               dataaa?.enddateValue,
//                               "YYYY-MM-DD"
//                             );
//                             let admission1 = moment(
//                               resd?.timeSeries2?.start,
//                               "YYYY-MM-DD"
//                             );
//                             let discharge1 = moment(
//                               resd?.timeSeries2?.end,
//                               "YYYY-MM-DD"
//                             );

//                             // const val =
//                             //  ( discharge.diff(admission, "days") ===
//                             //   discharge1.diff(admission1, "days") && resd?.timeSeries2?.start < moment().format("YYYY-MM-DD"))
//                             //     ? "" : ( discharge.diff(admission, "days") ===
//                             //   discharge1.diff(admission1, "days") && resd?.timeSeries2?.end >= moment().format("YYYY-MM-DD")) ?
//                             //   "active"
//                             //     : "";

//                             // return val;
//                             // console.log('ad--==',discharge.diff(admission, "days"))

//                             if (
//                               resd?.timeSeries2?.start == resd?.timeSeries2?.end
//                             ) {
//                               if (
//                                 discharge.diff(admission, "days") ===
//                                 discharge1.diff(admission1, "days")
//                               ) {
//                                 if (
//                                   resd?.timeSeries2?.start <
//                                   moment().format("YYYY-MM-DD")
//                                 ) {
//                                   return "";
//                                 } else {
//                                   return "active";
//                                 }
//                               }
//                             } else {
//                               if (
//                                 discharge.diff(admission, "days") ===
//                                 discharge1.diff(admission1, "days")
//                               ) {
//                                 if (
//                                   resd?.timeSeries2?.end >=
//                                   moment().format("YYYY-MM-DD")
//                                 ) {
//                                   return "active";
//                                 } else {
//                                   return "";
//                                 }
//                               }
//                             }
//                           })()}`}
//                         >
//                           {" "}
//                           {dataaa.name}
//                         </a>
//                       );
//                     })}
//                   </div>
//                 </div>

//                 <div className=" text-end">
//                   <span
//                     style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                     className="d-sm-inline ms_2 start_date_time_css"
//                   >
//                     {selectedTime.start}
//                   </span>
//                   <ForwardIcon />
//                   <span
//                     style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                     className="d-sm-inline mx_2 start_date_time_css"
//                   >
//                     {selectedTime.end}
//                   </span>

//                   <IconButton
//                     variant="text"
//                     size="small"
//                     sx={{
//                       color: "rgba(0, 0, 0, 0.6)",
//                     }}
//                     aria-describedby={
//                       Boolean(anchorEll) ? "simple-popover" : undefined
//                     }
//                     onClick={(event) => {
//                       setAnchorEll(event.currentTarget);
//                     }}
//                   >
//                     <CalendarMonthIcon />
//                   </IconButton>

//                   <Popover
//                     id={Boolean(anchorEll) ? "simple-popover" : undefined}
//                     open={Boolean(anchorEll)}
//                     anchorEl={anchorEll}
//                     onClose={() => {
//                       setAnchorEll(null);
//                     }}
//                     anchorOrigin={{
//                       vertical: "bottom",
//                       horizontal: "left",
//                     }}
//                     transformOrigin={{
//                       vertical: "top",
//                       horizontal: "left",
//                     }}
//                   >
//                     <DateRangePickerGraph />
//                   </Popover>
//                 </div>

             
//               </div>
//             </div>
//           </div>

//           <div className="card-body" >
//             {!open && dataGraph ? (
//               <>
//                 <div id="revenucostgraphFull" ref={downloadRef_revenuecost_graph} style={{background: "white"}}>
//                   {" "}
//                   {dataGraph.length == 0 ? (
//                     <div className="d-flex h-100 p-3">
//                       <div className="m-auto text-center">
//                         <h1>No Data</h1>
//                         <img
//                           style={{ width: "100px", maxWidth: "100%" }}
//                           src={CancelImg}
//                           alt=""
//                           srcset=""
//                         />
//                       </div>
//                     </div>
//                   ) : (
//                     <>
//                       <div className="d-flex flex-wrap justify-content-center mt-2 ">
//                         {dataGraph?.datasets?.map((dataaa, index) => {
//                           return (
//                             <div>
//                               <Button
//                                 className="me-3"
//                                 size="small"
//                                 sx={{
//                                   borderRadius: 2,
//                                   boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
//                                   backgroundColor: chartRef?.current?.data
//                                     ?.datasets?.[index]?.hidden
//                                     ? "grey"
//                                     : dataaa.backgroundColor,
//                                   color: "white",
//                                   textDecorationColor: "black",
//                                   textDecoration: chartRef?.current?.data
//                                     ?.datasets?.[index]?.hidden
//                                     ? "line-through"
//                                     : "none",
//                                   color: "white",
//                                 }}
//                                 variant="contained"
//                                 startIcon={
//                                   dataaa.icon ? (
//                                     <dataaa.icon />
//                                   ) : (
//                                     <CheckCircleIcon />
//                                   )
//                                 }
//                                 onClick={() => {
//                                   handleButtonClick(index);
//                                 }}
//                               >
//                                 {dataaa?.label}
//                               </Button>
//                             </div>
//                           );
//                         })}

//                         {isFullScreen ? (
//                           <>
//                             <div className="d-block">
//                               <CancelIcon onClick={exitFullScreen} />
//                             </div>
//                           </>
//                         ) : (
//                           <></>
//                         )}

//                         <div className="my-auto me-4">
//                   <div class="datePickerButtonsDashboard">
//                     {[
//                       // {
//                       //   name: "Yesterday",
//                       //   startdateValue: "",
//                       //   enddateValue: "",
//                       // },
//                       {
//                         name: "line",
//                         tooltipText: "Line Graph",
//                         icon: <ShowChartIcon/>
                        
//                       },

//                       {
//                         name: "bar",
//                         tooltipText: "Bar Graph",
//                         icon:<BarChartIcon/>
//                       },

                      
//                     ].map((dataaa, index) => {
//                       return (
//                         <a
//                           data-bs-toggle="tooltip"
//                           data-bs-placement="top"
//                           title={dataaa.tooltipText}
//                           onClick={() => {
//                           setBarIcons(dataaa.name)
//                           }}
//                           className={
//                             dataaa.name == barIcons ? "active" : ""
//                           }
//                         >
//                           {" "}
//                           {dataaa.icon}
//                         </a>
//                       );
//                     })}
//                   </div>
//                 </div>
//                 <div class="d-flex justify-content-between align-items-center mb-3">
//                                   <>
//                                     {" "}
//                                     <IconButton
//                                       aria-label="more"
//                                       id="long-button"
//                                       aria-controls={
//                                         openmenue4 ? "long-menu" : undefined
//                                       }
//                                       aria-expanded={
//                                         openmenue4 ? "true" : undefined
//                                       }
//                                       aria-haspopup="true"
//                                       onClick={handleClickmenue4}
//                                     >
//                                       <MoreVertIcon />
//                                     </IconButton>
//                                   </>
                         

//                                 <Menu
//                                   id="long-menu"
//                                   MenuListProps={{
//                                     "aria-labelledby": "long-button",
//                                   }}
//                                   style={{ zIndex: "9999999999" }}
//                                   anchorEl={anchorEl4}
//                                   open={openmenue4}
//                                   onClose={handleClosemenue4}
//                                   PaperProps={{
//                                     style: {
//                                       width: "auto",
//                                     },
//                                   }}
//                                   transformOrigin={{
//                                     horizontal: "right",
//                                     vertical: "top",
//                                   }}
//                                   anchorOrigin={{
//                                     horizontal: "right",
//                                     vertical: "bottom",
//                                   }}
//                                 >
//                                   <MenuItem
//                                     onClick={handleClickExcel_revenucostDATA}
//                                   >
//                                     {/* Save{" "}
//                                     {ViewTableForm == true
//                                       ? "Table"
//                                       : "Graph  "}{" "}
//                                     Data (Excel) */}
//                                     <DescriptionIcon style={{color:"Green"}}/>
//                                     Data in Excel
//                                   </MenuItem>

//                                   <MenuItem
//                                     onClick={
                                    
//                                         downloadChartAsPDF_revenucostDATA
//                                     }
//                                   >
//                                     {/* Save{" "}
//                                     {ViewTableForm == true
//                                       ? "Table"
//                                       : "Graph Image "}{" "}
//                                     (PDF) */}
//                                     <PictureAsPdfIcon style={{color:"Red"}}/>
//                                     Data in PDF
//                                   </MenuItem>

//                                   <MenuItem onClick={enterFullScreen}>
//                                   <AssessmentIcon style={{color:"#2191d0"}}/>
//                                     View Full{" "}
//                                     {ViewTableForm == true
//                                       ? "Table"
//                                       : "Graph  "}
                                      
//                                   </MenuItem>
//                                   <MenuItem
//                                     onClick={
//                                       downloadChartAsimage_revenucostDATA }
//                                   >
//                                   <ImageIcon style={{color:"orange"}}/>
//                                     {/* Save{" "}
//                                     {ViewTableForm == true
//                                       ? "Table"
//                                       : "Graph Image "}{" "}
//                                     (IMAGE) */}
//                                     Data in PNG
//                                   </MenuItem>
//                                 </Menu>
//                               </div> 
//                       </div>
//                       <Chart
//                         type={barIcons}
//                         options={options}
//                         data={dataGraph}
//                         onClick={handleClick}
//                         ref={chartRef}
//                       />
//                     </>
//                   )}{" "}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <Skeleton animation="wave" className="mt-3" />
//                 <Skeleton animation="wave" />
//                 <Skeleton animation="wave" />
//                 <Skeleton animation="wave" />
//                 <Skeleton animation="wave" />
//                 <Skeleton animation="wave" />
//                 <Skeleton animation="wave" />
//                 <Skeleton animation="wave" />
//                 <Skeleton animation="wave" />
//                 <Skeleton animation="wave" />
//               </>
//             )}

//             <div className="p-4">
//               {/* {dataGraph?.length == 0 ? (
//                 <>
//                   <Skeleton animation="wave" className="mt-3" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                 </>
//               ) : (
//                 <> */}
//               {/* <div className="revenucostprofit table-responsive">
             

//                 <table>
//                   <thead>
//                     <tr>
//                       {headerColumn.map((header, index) => (
//                         <th key={index}>{header.columnName}</th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {dataa.map((item, index) => (
//                       <tr key={index}>
//                         {headers.map((header, idx) => (
//                           <td key={idx}>{item[header]}</td>
//                         ))}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div> */}
//               {/* </>
//               )} */}

//               {open1 == true ? (
//                 <>
//                   <Skeleton animation="wave" className="mt-3" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                   <Skeleton animation="wave" />
//                 </>
//               ) : (
//                 <>
//                   {(data?.length > 0 && dataGraph?.datasets?.length > 0) ? (
//                     <>
//                       <div className="d-flex justify-content-between mt-3">
//                         <select
//                           value={TableStatus.pageSize}
//                           className="dropdown"
//                           onChange={(e) => {
//                             setPageSize(Number(e.target.value));
//                             setTableStatus({
//                               ...TableStatus,
//                               pageSize: e.target.value,
//                               pageNo: 0,
//                             });
                            
//                             setByDefaultTableApiNotHit(true);
//                           }}
                        
//                         >
//                           {[10, 25, 50].map((value, i) => {
//                             return (
//                               <option
//                                 className="dropdown-menu"
//                                 aria-labelledby="dropdownMenuButton1"
//                                 value={value}
//                                 key={value}
//                               >
//                                 Show {value}
//                               </option>
//                             );
//                           })}
//                         </select>
//                         <div className="my-auto">
//                           {/* <Tooltip title="Refresh"> */}
//                           <button
//                             type="submit"
//                             className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
//                             // onClick={RefreshBtn}
//                             onClick={() => RefreshBtn("Text to Copy")}
//                           >
//                             {/* <i class="material-icons opacity-10">refresh</i> */}
//                             <RefreshIcon />
//                           </button>
//                           {/* </Tooltip> */}
//                         </div>
//                       </div>
//                       <div class="table-responsive mt-3">
//                         <table
//                           {...getTableProps()}
//                           id="example"
//                           className="table blacklisting_table table-striped table-bordered dataTable table-sm"
//                           style={{ width: "100%" }}
//                           ref={downloadRef_revenuecost}
//                         >
//                           <thead>
//                             {headerGroups.map((headerGroup) => (
//                               <tr {...headerGroup.getHeaderGroupProps()}>
//                                 {headerGroup.headers.map((column) => (
//                                   <th
//                                     {...column.getHeaderProps(
//                                       column.getSortByToggleProps()
//                                     )}
//                                     className="text-center width_2"
//                                   >
//                                     {column.render("Header")}
//                                     <span>
//                                       {column.isSorted
//                                         ? column.isSortedDesc
//                                           ? "↑"
//                                           : "↓"
//                                         : ""}
//                                     </span>
//                                   </th>
//                                 ))}
//                               </tr>
//                             ))}
//                           </thead>
//                           <tbody {...getTableBodyProps()}>
//                             {page.map((row) => {
//                               prepareRow(row);
//                               return (
//                                 <tr {...row.getRowProps()}>
//                                   {row.cells.map((cell) => {
//                                     return (
//                                       <td
//                                         {...cell.getCellProps()}
//                                         className={
//                                           cell.column.Header == "Id" ||
//                                           cell.column.Header ==
//                                             "Total Upload" ||
//                                           cell.column.Header ==
//                                             "Total Success" ||
//                                           cell.column.Header ==
//                                             "Total Failure" ||
//                                           cell.column.Header == "Allready Exist"
//                                             ? "text-end"
//                                             : cell.column.Header ==
//                                                 "Download detail report" ||
//                                               cell.column.Header ==
//                                                 "Delivered" ||
//                                               cell.column.Header ==
//                                                 "Waiting For ACK" ||
//                                               cell.column.Header ==
//                                                 "Pushed To SMSC" ||
//                                               cell.column.Header ==
//                                                 "System Error" ||
//                                               cell.column.Header == "Nack" ||
//                                               cell.column.Header ==
//                                                 "Blacklist" ||
//                                               cell.column.Header == "Dnd"
//                                             ? "text-center"
//                                             : "text-start"
//                                         }
//                                       >
//                                         <div>{cell.render("Cell")}</div>
//                                       </td>
//                                     );
//                                   })}
//                                 </tr>
//                               );
//                             })}
//                           </tbody>
//                         </table>
//                       </div>

//                       <div className="d-flex justify-content-between mt -2">
//                         <div>
//                           <span>
//                             Page:
//                             <strong>
//                               {data1?.pageable?.pageNumber + 1} of{" "}
//                               {data1?.totalPages}
//                             </strong>
//                           </span>
//                         </div>

//                         <div className="prev_next d-flex align-items-center">
//                           <button
//                             className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
//                             type="button"
//                             onClick={() => {
//                               setByDefaultTableApiNotHit(true);
//                               setTableStatus({
//                                 ...TableStatus,
//                                 pageNo: 0,
//                               });
//                               setPaginationPage(1);
//                             }}
//                           >
//                             First
//                           </button>

//                           <Stack spacing={2}>
//                             <Pagination
//                               onChange={(event, value) => {
//                                 setByDefaultTableApiNotHit(true);
//                                 setTableStatus({
//                                   ...TableStatus,
//                                   pageNo: Number(value) - 1,
//                                 });
//                                 setPaginationPage(value);
//                               }}
//                               page={paginationPage}
//                               count={data1 ? data1?.totalPages : ""}
//                               variant="outlined"
//                               shape="rounded"
//                               color="primary"
//                             />
//                           </Stack>
//                           <button
//                             className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
//                             type="button"
//                             onClick={() => {
//                               setByDefaultTableApiNotHit(true);
//                               setTableStatus({
//                                 ...TableStatus,
//                                 pageNo: data1?.totalPages - 1,
//                               });
//                               setPaginationPage(data1?.totalPages);
//                             }}
//                           >
//                             Last
//                           </button>
//                         </div>
//                       </div>
//                     </>
//                   ) : (
//                     <>
//                       {/* {data?.length == 0 && (open || open1) ? null : (
//                         <div className="text-center mt-4">
//                           <h5>No Record Found..!!</h5>
//                         </div>
//                       )} */}
//                       {data?.length == 0 && (open || open1)
//                         ? null
//                         : dataGraph.length != 0 && (
//                             <>
//                               <div className="text-center mt-4">
//                                 <h5>No Record Found..!!</h5>
//                               </div>
//                             </>
//                           )}
//                       {/* <div className="text-center mt-4">
//                         {data?.length == 0 &&
//                         open == true ? null : data?.length == 0 &&
//                           open == undefined ? null : (
//                           <div className="text-center">
//                             <h5>No Record Found..!!</h5>
//                           </div>
//                         )}
//                       </div> */}
//                     </>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }





import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  Chart,
  getElementsAtEvent,
  getDatasetAtEvent,
  getElementAtEvent,
} from "react-chartjs-2";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  endOfYear,
  addMonths,
  subMonths,
  addYears,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
} from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useEffect, useMemo } from "react";
import { toast } from "react-toastify";
import { useState, useRef } from "react";
import {
  Backdrop,
  Button,
  IconButton,
  Popover,
  Skeleton,
  MenuItem,
} from "@mui/material";
import Loader from "../../../components/Loader";
import moment from "moment";
import { common_axios } from "../../../App";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import RefreshIcon from "@mui/icons-material/Refresh";
import Swal from "sweetalert2";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import CancelImg from "../../../assets/images/cancel.png";
import { setTimeSeries1 } from "../../../redux/features/dashboardSlice";
import { setTimeSeries2 } from "../../../redux/features/dashboardSlice";
import { actionid } from "../../../redux/features/pageSlices";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import PersonIcon from "@mui/icons-material/Person";
import ForwardIcon from "@mui/icons-material/Forward";
import DownloadingSharpIcon from "@mui/icons-material/DownloadingSharp";
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import BlockIcon from "@mui/icons-material/Block";
import SystemSecurityUpdateWarningIcon from "@mui/icons-material/SystemSecurityUpdateWarning";
// import Popover from "@mui/icons-material/Popover";
import DateRangePickerTransactional from "../Reports/Transcational/DateRangePickerTransactional";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DateRangePickerGraph from "./DateRancePickerGraph";
import Menu from "@mui/material/Menu";
import ShowChartIcon from '@mui/icons-material/ShowChart';
import BarChartIcon from '@mui/icons-material/BarChart';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ImageIcon from '@mui/icons-material/Image';
import DescriptionIcon from '@mui/icons-material/Description';
import * as XLSX from "xlsx";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { message } from "antd";
import { number } from "yup";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

// import DateRangePickerTransactional from "./DateRangePickerTransactional";

const generateLegendHtml = (chart) => {
  const { datasets } = chart.data;
  let legendHtml = "";

  datasets.forEach((dataset, index) => {
    const backgroundColor = dataset.backgroundColor[index];
    const label = dataset.label;

    // console.log({ label });

    legendHtml += `
      <div class="custom-legend">
        <span class="legend-color" style="background-color: ${backgroundColor}"></span>
        <span class="legend-label">${label}</span>
      </div>
    `;
  });

  return "this";
};

export function Successgraph() {
  const value = localStorage.getItem("dstQueCode1")?.split(",");
  const resd = useSelector((data) => data?.dashboardReducer);

  const [dataGraph, setDataGraph] = useState(null);
  const [data, setData] = useState([
    // {
    //   file_status: 1,
    //   delivered: 0,
    //   daily_Code: "2023-07-05",
    //   "Message Sent": 0,
    //   "Successfully Submited": 0,
    //   Download:
    //     "http://192.168.146.187:4902/sms/delivery-report/v1/download/transactional/130_2023_08_03_180730.xlsx",
    // },
    // {
    //   file_status: null,
    //   delivered: 0,
    //   daily_Code: "2023-07-08",
    //   "Message Sent": 0,
    //   "Successfully Submited": 0,
    //   Download: null,
    // },
  ]);

//  console.log("uy9uyhjoh", dataGraph);
  const [open, setOpen] = useState(true);
  const [open1, setOpen1] = useState(false);
const[barIcons,setBarIcons] = useState("line")
  const chartRef = useRef();
  const history = useHistory();
  const [data1, setData1] = useState([]);
  // console.log("ff", resd);
  const [globlecancel, setgloblecancel] = useState(false);

  const Tabs = localStorage.getItem("dashboardTopTabs");
  const dispatch = useDispatch();
  const [anchorEll, setAnchorEll] = React.useState(null);
  // const [TodayGraphApiNotHit, setTodayGraphApiNotHit] = useState(false);
  const [TodayGraphApiNotHit, setTodayGraphApiNotHit] = useState(
    Tabs == "3" || Tabs == "4" ? false : true
  );
  const selectedTime = useSelector(
    (state) => state.dashboardReducer.timeSeries2
  );
  const [Status, setStatus] = useState({
    approveType: selectedTime?.approveType
      ? selectedTime?.approveType
      : "Completed",
    resellerName: null,
    type: null,
    approveAssignedType: null,
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
    selectorType: null,
    startTime: null,
    tabs: 0,
    dateTabs0: null,
  });
  
// console.log("khjj",Status.pageNo)
  const [TableStatus, setTableStatus] = useState({
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [byDefaultTableApiNotHit, setByDefaultTableApiNotHit] = useState(false);

  const [paginationPage, setPaginationPage] = React.useState(1);
  const [loadingIndex, setLoadingIndex] = useState(-1);

  const handleLegendClick = (event, legendItem) => {
    // Access the clicked legend item
    legendItem.hidden = true;
  };

  const options = {
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },

    legend: {
      // display: false,
      // onClick: handleLegendClick,
    },
    stacked: false,
    //   plugins: {
    //     title: {
    //       display: true,
    //       text: "Approved Sender Id Types",
    //     },
    //   },

    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: (xDatapoint) => {
            if (isNaN(xDatapoint?.[0].label)) {
              return xDatapoint?.[0].label;
            } else {
              // var dateObj = new Date();
              // var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
              // var year = dateObj.getUTCFullYear();

              // const newdate = xDatapoint?.[0].label + "/" + month1 + "/" + year;

              // return newdate;

              return dataGraph?.labelsName?.[xDatapoint?.[0]?.dataIndex];
      
            }
          },
          // label: (yDatapoint) => {
          //   console.log({ yDatapoint }); // All list shown in color
          //   return "22";
          // },
        },
      },
      datalabels: {
        display: true,
        color: "transparent",
        align: "top",
        padding: {
          right: 2,
        },
      
        labels: {
          padding: { top: 10 },
          title: {
            font: {
              weight: "bold",
            },
          },
          value: {
            color: "transparent",
          },
        },
        formatter: function (value) {
          return "\n" + value;
        },
      },
    },

    onHover: (event, activeElements) => {
      // console.log({ activeElements });
      if (activeElements?.length > 0) {
        event.native.target.style.cursor = "pointer";
      } else {
        event.native.target.style.cursor = "auto";
      }
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
        ticks: {
          min: 0,
          max: 1,
          stepSize: 1,
          fontSize: 20,
        },
        title: {
          display: true,
          text: "<---- Count ---->",
          // color: "#911",
          font: {
            family: "Poppins, sans-serif",
            size: 20,
            weight: "bolder",
            lineHeight: 1.2,
          },
        },
      },
      x: {
        stacked: true,
        maxTicksLimit: 11,
        title: {
          display: true,
          text: `<---- ${
            (Tabs == 3 || Tabs == 4) && TodayGraphApiNotHit == false
              ? "Hours"
              : "Month"
          } ---->`,
          font: {
            family: "Poppins, sans-serif",
            size: 20,
            weight: "bolder",
            lineHeight: 1.2,
          },
        },
      },
      // x1: {
      //   ticks: {
      //     // For a category axis, the val is the index so the lookup via getLabelForValue is needed
      //     callback: function (val, index) {
      //       // Hide every 2nd tick label
      //       console.log(
      //         "TTTTTTTT",
      //         Math.floor(data?.labels?.length / 2),
      //         index,
      //         Math.floor(data?.labels?.length / 2) === index,
      //         data
      //       );
      //       return Math.floor(data?.labels?.length / 2) === index
      //         ? "Campaign Type"
      //         : null;
      //     },
      //   },
      // },

      // y1: {
      //   type: "linear",
      //   display: true,
      //   position: "right",
      //   grid: {
      //     drawOnChartArea: false,
      //   },
      // },
    },
  };
  const [rowData, setRowData] = useState([]);
  const [labelDate, setLabelDate] = useState([]);
  const assignUserApi = async (e) => {
    var date = moment(resd?.timeSeries?.end);
    var now = moment(resd?.timeSeries?.start);
    var duration = moment.duration(date.diff(now));
    var noofDays = duration.asDays();
    if (value[1] == "successM") {
      setDataGraph([]);

      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/table/graph`,
          {
            dashBoardRequest: {
              startDate: resd?.timeSeries2?.start,
              endDate: resd?.timeSeries2?.end,
              // startDate: "2023-08-01",
              // endDate: "2023-08-31",
              flag: "Success",
            },
          }
        );
        if (res.data?.statusDescription?.statusCode == 200) {
          // setData1(res.data);
          // TableDataGet1();
          setOpen(false);

          setRowData(res.data?.dataSets);
          setLabelDate(res.data.xaxisLabelDate);
          if (res.data?.dataSets?.length == 0) {
            setDataGraph([]);
          } else {
            res.data["dataSets1"] = [];
            let varrr = false;
            for (let index = 0; index < res.data?.dataSets.length; index++) {
              res.data.dataSets[index]["pointRadius"] = 0;
              res.data.dataSets[index]["clicked"] = true;

              if (res.data.dataSets[index].label == "Pushed To SMSC") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f";
                res.data.dataSets[index]["borderColor"] = "#f9442f";
                res.data.dataSets[index]["icon"] = StopCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;
                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#f9442f";
              }

              if (res.data.dataSets[index].label == "Delivered") {
                res.data.dataSets[index]["backgroundColor"] = "#5ab778";
                res.data.dataSets[index]["borderColor"] = "#5ab778";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;

                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#5ab778";
              }
              for (
                let i = 0;
                i < res.data?.dataSets[index]?.data?.length;
                i++
              ) {
                if (res.data?.dataSets[index]?.data[i] != 0) {
                  varrr = true;
                }
              }
            }
            if (!varrr) {
              setDataGraph([]);
            } else {
              if (value[1] == "successM") {
                setDataGraph({
                  labels: res.data?.xaxisLabelDate,
                  labelsName: res.data?.xaxisLabelDate,
                  labelsNumber: res.data?.xaxisLabels,
                  datasets: res.data?.dataSets1,

                  // datasets: [
                  //   {
                  //     label: "Pending for Approval",
                  //     data: [65, 29, 80, 31, 56, 39, 41, 65, 22, 89, 81],
                  //     borderColor: "#39CCCC",
                  //     // backgroundColor: "rgb(0,0,135)",
                  //     backgroundColor: "#39CCCC",
                  //     yAxisID: "y",
                  //     tension: 0.5,
                  //   },
                  //   {
                  //     label: "Active",
                  //     data: [76, 29, 92, 61, 60, 52, 46, 87, 59, 90, 81],
                  //     borderColor: "#D81B60",
                  //     // backgroundColor: "rgb(117,217,239)",
                  //     backgroundColor: "#D81B60",
                  //     yAxisID: "y1",
                  //     tension: 0.5,
                  //   },
                  //   {
                  //     label: "In Process",
                  //     data: [50, 17, 60, 44, 26, 14, 29, 15, 59, 89, 51],
                  //     borderColor: "#FF851B",
                  //     // backgroundColor: "rgb(80,108,120)",
                  //     backgroundColor: "#FF851B",
                  //     yAxisID: "y1",
                  //     tension: 0.5,
                  //   },
                  //   {
                  //     label: "Rejected",
                  //     data: [10, 9, 37, 41, 21, 28, 11, 35, 24, 67, 61],
                  //     borderColor: "#605CA8)",
                  //     // backgroundColor: "rgb(216,217,221)",
                  //     backgroundColor: "#605CA8",
                  //     yAxisID: "y1",
                  //     tension: 0.5,
                  //   },
                  // ],
                });
              }
            }
          }
          // setOpen(false);
        } else {
          setDataGraph([]);
          setOpen(false);
        }
      } catch (error) {
        setDataGraph([]);
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      setDataGraph([]);

      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/table/graph`,
          {
            dashBoardRequest: {
              // startDate: "2023-08-01",
              // endDate: "2023-08-31",
              startDate: resd?.timeSeries2?.start,
              endDate: resd?.timeSeries2?.end,
              flag: "Failed",
            },
          }
        );

        if (res.data?.statusDescription.statusCode == 200) {
          // TableDataGet1();

          setRowData(res.data?.dataSets);
          setLabelDate(res.data.xaxisLabelDate);
          setOpen(false);

          if (res.data?.dataSets?.length == 0) {
            setDataGraph([]);
          } else {
            let varrr = false;
            res.data["dataSets1"] = [];
            for (let index = 0; index < res.data?.dataSets?.length; index++) {
              res.data.dataSets[index]["pointRadius"] = 0;
              res.data.dataSets[index]["clicked"] = true;

              if (res.data.dataSets[index].label == "Dnd") {
                res.data.dataSets[index]["backgroundColor"] = "#536878";
                res.data.dataSets[index]["borderColor"] = "#536878";
                res.data.dataSets[index]["icon"] = BlockIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;

                res.data.dataSets[index]["pointHoverRadius"] = 6;
                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#536878";
              }
              if (res.data.dataSets[index].label == "Blacklist") {
                res.data.dataSets[index]["backgroundColor"] = "#221133";
                res.data.dataSets[index]["borderColor"] = "#221133";
                res.data.dataSets[index]["icon"] = CancelIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;
                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#221133";
              }
              if (res.data.dataSets[index].label == "Nack") {
                res.data.dataSets[index]["backgroundColor"] = "#a40000";
                res.data.dataSets[index]["borderColor"] = "#a40000";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;

                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#a40000";
              }

              if (res.data.dataSets[index].label == "System Error") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f";
                res.data.dataSets[index]["borderColor"] = "#f9442f";
                res.data.dataSets[index]["icon"] =
                  SystemSecurityUpdateWarningIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;

                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#f9442f";
              }
              if (res.data.dataSets[index].label == "Message Sent") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f";
                res.data.dataSets[index]["borderColor"] = "#f9442f";
                res.data.dataSets[index]["icon"] = StopCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
              }
              if (res.data.dataSets[index].label == "Waiting For ACK") {
                res.data.dataSets[index]["backgroundColor"] = "orange";
                res.data.dataSets[index]["borderColor"] = "orange";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;
                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "orange";
              }
              if (res.data.dataSets[index].label == "Delivered") {
                res.data.dataSets[index]["backgroundColor"] = "#5ab778";
                res.data.dataSets[index]["borderColor"] = "#5ab778";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
              }
              for (
                let i = 0;
                i < res.data?.dataSets[index]?.data?.length;
                i++
              ) {
                if (res.data?.dataSets[index]?.data[i] != 0) {
                  varrr = true;
                }
              }
            }
            if (!varrr) {
              setDataGraph([]);
            } else {
              if (value[1] != "successM") {
                setDataGraph({
                  labels: res.data?.xaxisLabelDate,

                  datasets: res.data?.dataSets1,
                });
              }
            }
          }
          // setOpen(false);
        } else {
          setDataGraph([]);
          setOpen(false);
        }
      } catch (error) {
        // console.error({ error });

        setDataGraph([]);

        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };
  // useEffect(() => {
  //   if ((Tabs == "3" || Tabs == "4" ) && TodayGraphApiNotHit == false) {
  //     TodayGraphApi();
  //     TodayTableDataGet();
  //   } 
  
  //   else {
  //     assignUserApi();
  //     TableDataGet1();
  //   }
  // }, [
  //   resd?.timeSeries2?.start,
  //   resd?.timeSeries2?.end,
  //   resd?.product,
  //   resd?.productType,
  //   // resd?.showBy,
  //   // value,
  // ]);


  useEffect(() => {
    if ((Tabs == "3" || Tabs == "4") && TodayGraphApiNotHit == false) {
      TodayGraphApi();
      TodayTableDataGet();
    }
    // else if((Tabs == "0" || Tabs == "1" ) && TodayGraphApiNotHit == true) {
    //   TodayGraphApi();
    //   TodayTableDataGet();
    // }
    else {
      if (TodayGraphApiNotHit == true) {
        assignUserApi();
        TableDataGet1();
      } else {
        TodayGraphApi();
        TodayTableDataGet();
      }
    }
  }, [
    resd?.timeSeries2?.start,
    resd?.timeSeries2?.end,
    resd?.product,
    resd?.productType,

    // resd?.showBy,
    // value,
  ]);


// useEffect(()=>{
// if(Tabs == "0" || Tabs == "1"){
//   setTodayGraphApiNotHit(true)
// } 
// },[Tabs])

  // console.log("ddd", Tabs);

  const globalData = useSelector((state) => state.dashboardReducer);

  const printDatasetAtEvent = (dataset) => {
    if (!dataset.length) return;

    const datasetIndex = dataset[0].datasetIndex;

    // console.log(data.datasets[datasetIndex].status);

    return dataGraph.datasets[datasetIndex].status;
  };

  const printElementAtEvent = (element) => {
    if (!element.length) return;

    const { datasetIndex, index } = element[0];

    // console.log(data.labels[index], data.datasets[datasetIndex].data[index]);
    return dataGraph.labels[index];
  };

  const printElementsAtEvent = (elements) => {
    if (!elements.length) return;

    // console.log(elements.length);
    return elements.length;
  };

  const printElementIndexAtEvent = (element) => {
    if (!element.length) return;

    const { datasetIndex, index } = element[0];

    return [index];
  };

  const handleClick = (event) => {
    // console.log("mm", getDatasetAtEvent(chartRef.current, event),printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)),printElementAtEvent(getElementAtEvent(chartRef.current, event)), printElementIndexAtEvent(
    //   getElementAtEvent(chartRef.current, event)
    // ))
    // console.log("first",printElementAtEvent(getElementAtEvent(chartRef.current, event)),)
    //  alert("Now clikced");
    // console.log("aaa",dataGraph.datasets[getDatasetAtEvent(chartRef.current, event)[0].datasetIndex])

    let Datee = printElementAtEvent(getElementAtEvent(chartRef.current, event));
    let Labell =
      dataGraph.datasets[
        getDatasetAtEvent(chartRef.current, event)[0].datasetIndex
      ];
    localStorage.setItem("GraphPointer", `${Datee},${Labell.label}`);

    // console.log(
    //   "IIIIIIII",
    //   printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)),
    //   printElementAtEvent(getElementAtEvent(chartRef.current, event)),
    //   !isNaN(
    //     data?.labelsNumber?.[
    //       printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
    //     ]
    //   )
    // );
    var dateObj = new Date();
    var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
    var year = dateObj.getUTCFullYear();

    const newdate =
      year +
      "-" +
      month1 +
      "-" +
      printElementAtEvent(getElementAtEvent(chartRef.current, event));

    // if (printElementAtEvent(getElementAtEvent(chartRef.current, event))) {
    //   localStorage?.setItem(
    //     "dstQueCode1",
    //     `${newdate},${printDatasetAtEvent(
    //       getDatasetAtEvent(chartRef.current, event)
    //     )}`
    //   );

    // }

    if (
      // !isNaN(printElementAtEvent(getElementAtEvent(chartRef.current, event)))
      !isNaN(
        dataGraph?.labelsNumber?.[
          printElementIndexAtEvent(getElementAtEvent(chartRef.current, event))
        ]
      )
    ) {
      var dateObj = new Date();
      var month1 = dateObj.getUTCMonth() + 1; //months from 1-12
      var year = dateObj.getUTCFullYear();

      const newdate =
        year +
        "-" +
        month1 +
        "-" +
        printElementAtEvent(getElementAtEvent(chartRef.current, event));

      if (printElementAtEvent(getElementAtEvent(chartRef.current, event))) {
        // localStorage?.setItem(
        //   "dstQueCode1",
        //   `${newdate},${printDatasetAtEvent(
        //     getDatasetAtEvent(chartRef.current, event)
        //   )},${value}`
        // );

        // localStorage?.setItem(
        //   "dstQueCode1",
        //   `${
        //     dataGraph?.labelsName?.[
        //       printElementIndexAtEvent(
        //         getElementAtEvent(chartRef.current, event)
        //       )
        //     ]
        //   },${printDatasetAtEvent(
        //     getDatasetAtEvent(chartRef.current, event)
        //   )},${value}`
        // );

        if (
          printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event)) == 1
        ) {
          if (
            JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
            "ROLE_SUPER_ADMIN"
          ) {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignsControl");
          } else {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignControl");
          }
        } else {
          // dispatch(
          //   setTimeSeries2({
          //     end: `${
          //       dataGraph?.labelsName?.[
          //         printElementIndexAtEvent(
          //           getElementAtEvent(chartRef.current, event)
          //         )
          //       ]
          //     }`,

          //     start: `${
          //       dataGraph?.labelsName?.[
          //         printElementIndexAtEvent(
          //           getElementAtEvent(chartRef.current, event)
          //         )
          //       ]
          //     }`,
          //     dateType: "Daily",
          //     approveType:
          //       printDatasetAtEvent(
          //         getDatasetAtEvent(chartRef.current, event)
          //       ) == 5
          //         ? "Stopped"
          //         : "Completed",
          //   })
          // );
          document.getElementsByName("sidebarLiReports")?.[0]?.click();
          // history?.push("/dashboard/SuccessGraphAll");
          if (value[1] == "successM") {
            history?.push("/dashboard/SuccessGraph/SuccessGraphReports");
          } else {
            history?.push("/dashboard/FailedGraph/FailedGraphReports");
          }
        }
      } else {
      }
    } else {
      // console.log(
      //   "PPPPPP",

      //   moment()
      //     .month(
      //       printElementAtEvent(getElementAtEvent(chartRef.current, event))
      //     )
      //     .format("M"),
      //   moment().format("M"),
      //   typeof moment().month("feb").format("M")
      // );

      if (
        Number(
          moment()
            .month(
              printElementAtEvent(getElementAtEvent(chartRef.current, event))
            )
            .format("M")
        ) <= Number(moment().format("M"))
      ) {
        const endDate = moment(
          moment().month(
            printElementAtEvent(getElementAtEvent(chartRef.current, event))
          )
        )
          .endOf("month")
          .format("YYYY-MM-DD");
        const startDate = moment(
          moment().month(
            printElementAtEvent(getElementAtEvent(chartRef.current, event))
          )
        )
          .startOf("month")
          .format("YYYY-MM-DD");
        // localStorage?.setItem(
        //   "dstQueCode1",
        //   `${startDate},${printDatasetAtEvent(
        //     getDatasetAtEvent(chartRef.current, event)
        //   )},${value},${endDate}`
        // );
        if (getDatasetAtEvent(chartRef.current, event) == 1) {
          if (
            JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
            "ROLE_SUPER_ADMIN"
          ) {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignsControl");
          } else {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignControl");
          }
        } else {
          // dispatch(
          //   setTimeSeries2({
          //     end: `${endDate}`,
          //     start: `${startDate}`,
          //     dateType: "Daily",
          //     approveType:
          //       printDatasetAtEvent(
          //         getDatasetAtEvent(chartRef.current, event)
          //       ) == 5
          //         ? "Stopped"
          //         : "Completed",
          //   })
          // );
          document.getElementsByName("sidebarLiReports")?.[0]?.click();
          // history?.push("/dashboard/SuccessGraphAll");
          if (value[1] == "successM") {
            history?.push("/dashboard/SuccessGraph/SuccessGraphReports");
          } else {
            history?.push("/dashboard/FailedGraph/FailedGraphReports");
          }
        }
      } else {
        const endDate = moment(
          moment(
            moment().month(
              printElementAtEvent(getElementAtEvent(chartRef.current, event))
            )
          ).endOf("month")
        )
          .add(-1, "y")
          .format("YYYY-MM-DD");
        const startDate = moment(
          moment(
            moment().month(
              printElementAtEvent(getElementAtEvent(chartRef.current, event))
            )
          ).startOf("month")
        )
          .add(-1, "y")
          .format("YYYY-MM-DD");

        // localStorage?.setItem(
        //   "dstQueCode1",
        //   `${startDate},${printDatasetAtEvent(
        //     getDatasetAtEvent(chartRef.current, event)
        //   )},${value},${endDate}`
        // );
        if (getDatasetAtEvent(chartRef.current, event) == 1) {
          if (
            JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
            "ROLE_SUPER_ADMIN"
          ) {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignsControl");
          } else {
            dispatch(actionid("1"));
            document
              .getElementsByName("sidebarLiCampaign Manager")?.[0]
              ?.click();
            history.replace("/dashboard/CampaignControl");
          }
        } else {
          // dispatch(
          //   setTimeSeries2({
          //     end: `${endDate}`,
          //     start: `${startDate}`,
          //     dateType: "Daily",
          //     approveType:
          //       printDatasetAtEvent(
          //         getDatasetAtEvent(chartRef.current, event)
          //       ) == 5
          //         ? "Stopped"
          //         : "Completed",
          //   })
          // );
          document.getElementsByName("sidebarLiReports")?.[0]?.click();
          // history?.push("/dashboard/SuccessGraphAll");
          if (value[1] == "successM") {
            history?.push("/dashboard/SuccessGraph/SuccessGraphReports");
          } else {
            history?.push("/dashboard/FailedGraph/FailedGraphReports");
          }
        }
      }
    }

    // history?.push("/dashboard/TransactionalReports");
    // printDatasetAtEvent(getDatasetAtEvent(chartRef.current, event));
    // printElementAtEvent(getElementAtEvent(chartRef.current, event));
    // printElementsAtEvent(getElementsAtEvent(chartRef.current, event));
  };

  const handleButtonClick = (index) => {
    // console.log(chartRef.current.data.dataset);
    let dataaa = [...dataGraph?.datasets];
    dataaa[index].clicked = !dataaa[index].clicked;
    setDataGraph({
      ...dataGraph,
      datasets: dataaa,
    });
    chartRef.current.data.datasets[index].hidden =
      !chartRef.current.data.datasets[index].hidden;
    chartRef.current.update();
  };

  // ...................Table...............................................................................//

  // console.log("coooo--", headerColumn);
  // const columns = [
  //   {
  //     Header: "Name",
  //     accessor: "name",
  //   },
  //   {
  //     Header: "Age",
  //     accessor: "age",
  //   },
  //   {
  //     Header: "City",
  //     accessor: "city",
  //   },
  // ];
  const [columns, setColumns] = useState([]);
  // console.log("co--==", columns);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };
  const [headerColumn, setHeaderColumn] = useState([]);
  // console.log("co--", headerColumn, rowData);
  const [serialNo, setSerialNo] = useState();
  // ..................................GetApi.......................................................//
  async function Tableget() {
    // setData([]);
    let temp = [];
    let Sno = {
      Header: "Id",
      accessor: "id",
      Cell: (cell) => {
        // console.log(
        //   "cell--==",
        //   cell.row.index + 1,
        //   cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize
        // );
        return (
          <>
            {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
          </>
        );
      },
    };
    setSerialNo(Sno);
    // let dateColumn = {

    //     Header: "Date",

    //     accessor: "Date",
    //     Cell: (cell) => {
    //       return (
    //         <>
    //           <Link

    //             style={{
    //               textDecoration: "underline",
    //               // color: "blue",
    //               fontWeight: "bolder",
    //             }}
    //             to={`/dashboard/TransactionalReport/All`}
    //           >
    //             {cell?.row?.original?.Date}
    //           </Link>

    //         </>
    //       );

    //   },
    // }
    let downloadColumn = {
      Header: "Download",
      accessor: "download",
      // Cell: ({ row }) => (
      //   <button>Download</button>
      // ),
      Cell: (cell) => {
        return (
          <>
            {cell.row.original.Download == null ? (
              <>
                <div className="">
                  <button
                    type="button"
                    className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
                    id="btn_Update"
                    style={{ width: "auto" }}
                    onClick={() => {
                      DownloadAction(cell);
                    }}
                    // disabled={DownloadDisable}
                  >
                    {/* Download Request */}
                    <DownloadingSharpIcon />
                  </button>
                </div>
              </>
            ) : cell.row.original.Download === "" ? (
              <>
                <Box
                  sx={{ display: "block", width: "100px" }}
                  className="mx-auto"
                >
                  <CircularProgress style={{ width: "31px", height: "31px" }} />
                </Box>
              </>
            ) : (
              <>
                <div className="">
                  <button
                    className="btn color_1 px-2"
                    type="button"
                    id=""
                    data-bs-toggle=""
                    aria-expanded="false"
                    onClick={() => {
                      downloadFile(cell);
                    }}
                  >
                    <FileDownloadIcon />
                  </button>
                </div>
              </>
            )}
          </>
        );
      },
    };
    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/status`,
        {
          status: value[1] == "successM" ? 3 : 2,
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        await setHeaderColumn(result.data.messageStatusTables);
        temp.push(Sno);
       
        // temp.push(dateColumn);
        for (let i = 0; i < result.data.messageStatusTables.length; i++) {
          // console.log("co--",result.data.messageStatusTables[i].columnName)
         if (result.data.messageStatusTables[i].columnName == "S.No") {
          }
          else if (result.data.messageStatusTables[i].columnName == "Date") {
            // alert("enter")
           await temp.push({
              Header: result.data.messageStatusTables[i].columnName,
              accessor: result.data.messageStatusTables[i].columnName,
              Cell: (cell) => {
                return (
                  <>
                    {value[1] == "successM" ? (
                      <>
                        <Link
                          style={{
                            textDecoration: "underline",
                            // color: "blue",
                            fontWeight: "bolder",
                          }}
                          to={`/dashboard/SuccessGraph/SuccessGraphReports`}
                          onClick={() => {
                            localStorage.setItem(
                              "dailyCode",
                              `${cell.row.original.Date}`
                            );
                          }}
                        >
                          {cell?.row?.original?.Date}
                        </Link>
                      </>
                    ) : (
                      <>
                        <Link
                          style={{
                            textDecoration: "underline",
                            // color: "blue",
                            fontWeight: "bolder",
                          }}
                          to={`/dashboard/FailedGraph/FailedGraphReports`}
                          onClick={() => {
                            localStorage.setItem(
                              "dailyCode",
                              `${cell.row.original.Date}`
                            );
                          }}
                        >
                          {cell?.row?.original?.Date}
                        </Link>
                      </>
                    )}
                  </>
                );
              },
            });
          }
          else if (result.data.messageStatusTables[i].columnName == "Download detail report") {
           
           await temp.push({
              Header: result.data.messageStatusTables[i].columnName,
              accessor: result.data.messageStatusTables[i].columnName,
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.Download == null ? (
                      <>
                        <div className="">
                          <button
                            type="button"
                            className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
                            id="btn_Update"
                            style={{ width: "auto" }}
                            onClick={() => {
                              DownloadAction(cell);
                            }}
                            // disabled={DownloadDisable}
                          >
                            {/* Download Request */}
                            <DownloadingSharpIcon />
                          </button>
                        </div>
                      </>
                    ) : cell.row.original.Download === "" ? (
                      <>
                        <Box
                          sx={{ display: "block", width: "100px" }}
                          className="mx-auto"
                        >
                          <CircularProgress style={{ width: "31px", height: "31px" }} />
                        </Box>
                      </>
                    ) : (
                      <>
                        <div className="">
                          <button
                            className="btn color_1 px-2"
                            type="button"
                            id=""
                            data-bs-toggle=""
                            aria-expanded="false"
                            onClick={() => {
                              downloadFile(cell);
                            }}
                          >
                            <FileDownloadIcon />
                          </button>
                        </div>
                      </>
                    )}
                  </>
                );
              },
            });
          }

        
          else {
            temp.push({
              Header: result.data.messageStatusTables[i].columnName,
              accessor: result.data.messageStatusTables[i].columnName,
            });
          }
        }
        // temp.splice(1, 1);
        // temp.push(downloadColumn);
        // console.log("temp--", temp);
        // const indexToRemove = temp.length - 2;
        // if (indexToRemove >= 0) {
        //   temp.splice(indexToRemove, 1);
        // }
        setColumns(temp);

        // await setHeaderColumn1(result.data.fileUploads);
      } else {
        setOpen(false);
        setHeaderColumn([]);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }
  useEffect(() => {
    let dynamicColumns = [...columns];
    let Sno = {
      Header: "Id",
      accessor: "id",
      Cell: (cell) => {
        // console.log(
        //   "cell--==",
        //   cell.row.index + 1,
        //   cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize
        // );
        return (
          <>
            {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
          </>
        );
      },
    };
    dynamicColumns[0] = Sno;
    setColumns(dynamicColumns);
  }, [TableStatus.pageNo, TableStatus.pageSize]);

  // useEffect(()=>{
  //   let temp=[]
  //   for(let i=0;i<columns.length;i++){
  //     if(columns[i].Header==serialNo.Header){
  //       temp.push(serialNo)
  //     }
  //     else{
  //       temp.push(columns[i])
  //     }
  //   }
  //   setColumns(temp)
  // },[TableStatus.pageNo, TableStatus.pageSize,serialNo])

  // ..................................Post Api.......................................................//

  async function TableDataGet() {
    setData([]);
    setOpen1(true);

    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/table/data`,
        // {
        //   status: value[1] == "successM" ? 3 : 2,
        // }

        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
          dashBoardRequest: {
            reportType:
              value[1] == "successM" ? "Success Message" : "Failed Message",

            startDate: resd?.timeSeries2?.start,
            endDate: resd?.timeSeries2?.end,
          },
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        setData(result.data.succesOrFailedMessageTableDatas.content);
        setData1(result.data.succesOrFailedMessageTableDatas);
        setOpen1(false);
      }
      else if (result.data.statusDescription.statusCode == 220){
        setOpen1(false);
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: result.data.statusDescription.statusMessage,
        // });
      } else {
        setOpen1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setOpen1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }
  async function TableDataGet1() {
    setData([]);
    setOpen(true);

    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/table/data`,
        // {
        //   status: value[1] == "successM" ? 3 : 2,
        // }

        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
          dashBoardRequest: {
            reportType:
              value[1] == "successM" ? "Success Message" : "Failed Message",

            startDate: resd?.timeSeries2?.start,
            endDate: resd?.timeSeries2?.end,
          },
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        setData(result.data.succesOrFailedMessageTableDatas.content);
        setData1(result.data.succesOrFailedMessageTableDatas);
        setOpen(false);
      } else if (result.data.statusDescription.statusCode == 220){
        setOpen1(false);
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: result.data.statusDescription.statusMessage,
        // });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }

  useEffect(() => {
    if (byDefaultTableApiNotHit == true) {
      TableDataGet();
    }
  }, [
    TableStatus.pageNo,
    TableStatus.pageSize,
    // resd?.timeSeries2?.start,
    // resd?.timeSeries2?.end,
  ]);
  // ......................................Loader API.........................................................//

  async function TableLoader() {
    try {
      if (TodayGraphApiNotHit == true) {
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/table/data`,
          // {
          //   status: value[1] == "successM" ? 3 : 2,
          // }
          {
            pageNo: TableStatus?.pageNo,
            pageSize: TableStatus?.pageSize,
            dashBoardRequest: {
              reportType:
                value[1] == "successM" ? "Success Message" : "Failed Message",

              startDate: resd?.timeSeries2?.start,
              endDate: resd?.timeSeries2?.end,
            },
          }
        );
        if (result.data.statusDescription.statusCode == 200) {
          setData(result.data.succesOrFailedMessageTableDatas.content);
          setData1(result.data.succesOrFailedMessageTableDatas);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusDescription.statusdescription,
          });
        }
      } else {
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/today-yesterday/message/data`,
          // {
          //   status: value[1] == "successM" ? 3 : 2,
          // }

          {
            pageNo: TableStatus?.pageNo,
            pageSize: TableStatus?.pageSize,
            dashBoardRequest: {
              reportType:
                value[1] == "successM" ? "Today Success" : "Today Failed",
              dailyCode:
                Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
            },
          }
        );
        if (result.data.statusDescription.statusCode == 200) {
          setData(result.data.succesOrFailedMessageTableDatas.content);
          setData1(result.data.succesOrFailedMessageTableDatas);
          setOpen1(false);
        } else {
          setOpen1(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusDescription.statusdescription,
          });
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }
  // ..................................................................................................//
  // const currentMonth = moment().format("MM");
  // const currentYear = moment().format("YYYY");

  useEffect(() => {
    return () => {
      dispatch(setTimeSeries2(JSON.parse(localStorage.getItem("TimeSeries2"))));
    };
  }, []);

  // .................Refresh Btn Api.....................................................................................//

  async function RefreshBtn() {
    setData([]);
    setOpen1(true);

    try {
      if (TodayGraphApiNotHit == true) {
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/message/table/data`,
          // {
          //   status: value[1] == "successM" ? 3 : 2,
          // }

          {
            pageNo: TableStatus?.pageNo,
            pageSize: TableStatus?.pageSize,
            dashBoardRequest: {
              reportType:
                value[1] == "successM" ? "Success Message" : "Failed Message",

              startDate: resd?.timeSeries2?.start,
              endDate: resd?.timeSeries2?.end,
            },
          }
        );
        if (result.data.statusDescription.statusCode == 200) {
          setData(result.data.succesOrFailedMessageTableDatas.content);
          setData1(result.data.succesOrFailedMessageTableDatas);
          setOpen1(false);
        }  else if (result.data.statusDescription.statusCode == 220){
          setOpen1(false);
          // Swal.fire({
          //   icon: "error",
          //   title: "Oops...",
          //   text: result.data.statusDescription.statusMessage,
          // });
        }else {
          setOpen1(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusDescription.statusdescription,
          });
        }
      } else {
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/today-yesterday/message/data`,
          // {
          //   status: value[1] == "successM" ? 3 : 2,
          // }

          {
            pageNo: TableStatus?.pageNo,
            pageSize: TableStatus?.pageSize,
            dashBoardRequest: {
              reportType:
                value[1] == "successM" ? "Today Success" : "Today Failed",
              dailyCode:
                Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
            },
          }
        );
        if (result.data.statusDescription.statusCode == 200) {
          setData(result.data.succesOrFailedMessageTableDatas.content);
          setData1(result.data.succesOrFailedMessageTableDatas);
          setOpen1(false);
        } else {
          setOpen1(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusDescription.statusdescription,
          });
        }
      }
    } catch (error) {
      setOpen1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }

  // .......................................................................................................................//

  const [downloadModelOpen, setDownloadModel] = useState(undefined);
  const [tableLoaderIndex, setTableLoaderIndex] = useState();
  // console.log("date--", downloadModelOpen);

  const modelButtonDownload = useRef(null);
  const DownloadAction = async (cell) => {
    // console.log("date11--", date);
    setDownloadModel(cell.row.original);
    // setTableLoaderIndex(index);
    await modelButtonDownload.current.click();
  };

  async function DownloadActionget() {
    try {
      if (TodayGraphApiNotHit == true ) {
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/download/current-month/succes-failed/message/report`,
          // "http://192.168.167.66:5002/v1/get-all/file",
          {
            downloadReportRequest: {
              // reportType:"Success Message",
              reportType:
                value[1] == "successM" ? "Success Message" : "Failed Message",
              dailyCode: downloadModelOpen.Date,
              pstatus: value[1] == "successM" ? 3 : 2,
            },
          }
        );
        if (result.data.statusDescription.statusCode == 200) {
          TableLoader();
        } else {
          // setTableLoader(false);
          // setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          // console.log(result.data.statusMessage);
        }
      } else {
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/download/today-yesterday/succes-failed/message/report`,

          // "http://192.168.167.66:5002/v1/get-all/file",
          {
            downloadReportRequest: {
              reportType:
                value[1] == "successM" ? "Today Success" : "Today Failed",
              dailyCode: downloadModelOpen.Date,
              pstatus: value[1] == "successM" ? 3 : 2,
              startDate: `${resd?.timeSeries2?.start} ${downloadModelOpen.Hour}:00:00`,
              endDate: `${resd?.timeSeries2?.end} ${downloadModelOpen.Hour}:59:59`,
              hourCode: downloadModelOpen.Hour,
            },
          }
        );
        if (result.data.statusDescription.statusCode == 200) {
          TableLoader();
        } else {
          // setTableLoader(false);
          // setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          // console.log(result.data.statusMessage);
        }
      }
    } catch (error) {
      // setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  const headers = [
    "daily_Code",
    "delivered",
    "message_Sent",
    "successfully_Submited",
  ];
  const dataa = [
    {
      delivered: 0,
      daily_Code: "2023-07-18",
      message_Sent: 0,
      successfully_Submited: 10,
    },
    {
      delivered: 0,
      daily_Code: "2023-07-18",
      message_Sent: 0,
      successfully_Submited: 20,
    },
    {
      delivered: 0,
      daily_Code: "2023-07-19",
      message_Sent: 10,
      successfully_Submited: 40,
    },
  ];

  //   const downloadFile = (cell) => {
  //   // console.log("hlooooooo");
  //   // alert("hii");
  //   window.location.href = cell.row.original.Download; //to download the file from url in download button
  // };

  const downloadFile = async (cell) => {
    //  console.log(cell.row.original.Download,"kkjhh")
    try {
      const response = await common_axios.get(
        `${cell?.row?.original?.Download}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            UserId: `${localStorage.getItem("UserId")}`,
            Source: "web",
          },
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `excel-file.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      // console.error(error);
    }
  };

  // .....................................Today Tab APIs............................................................//

  const TodayGraphApi = async (e) => {
    var date = moment(resd?.timeSeries?.end);
    var now = moment(resd?.timeSeries?.start);
    var duration = moment.duration(date.diff(now));
    var noofDays = duration.asDays();
    if (value[1] == "successM") {
      setDataGraph([]);
      // alert("lkj")
      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/table/today-yesterday/graph`,
          {
            dashBoardRequest: {
              // dailyCode: resd?.timeSeries2?.start,
              dailyCode:
                Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
              // startDate: "2023-08-01",
              // endDate: "2023-08-31",
              flag: "Success",
            },
          }
        );
        if (res.data?.statusDescription?.statusCode == 200) {
          // setData1(res.data);
          // TableDataGet1();
          setOpen(false);
          setRowData(res.data?.dataSets);
          setLabelDate(res.data.xaxixLabelHour);
          // localStorage.removeItem("dashboardTopTabs")
          if (res.data?.dataSets?.length == 0) {
            setDataGraph([]);
          } else {
            res.data["dataSets1"] = [];
            let varrr = false;
            for (let index = 0; index < res.data?.dataSets.length; index++) {
              res.data.dataSets[index]["pointRadius"] = 0;
              res.data.dataSets[index]["clicked"] = true;

              if (res.data.dataSets[index].label == "Pushed To SMSC") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f";
                res.data.dataSets[index]["borderColor"] = "#f9442f";
                res.data.dataSets[index]["icon"] = StopCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;
                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#f9442f";
              }

              if (res.data.dataSets[index].label == "Delivered") {
                res.data.dataSets[index]["backgroundColor"] = "#5ab778";
                res.data.dataSets[index]["borderColor"] = "#5ab778";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;

                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#5ab778";
              }
              for (
                let i = 0;
                i < res.data?.dataSets[index]?.data?.length;
                i++
              ) {
                if (res.data?.dataSets[index]?.data[i] != 0) {
                  varrr = true;
                }
              }
            }
            if (!varrr) {
              setDataGraph([]);
            } else {
              if (value[1] == "successM") {
                setDataGraph({
                  labels: res.data?.xaxixLabelHour,
                  labelsName: res.data?.xaxixLabelHour,
                  labelsNumber: res.data?.xaxisLabels,
                  datasets: res.data?.dataSets1,

                  // datasets: [
                  //   {
                  //     label: "Pending for Approval",
                  //     data: [65, 29, 80, 31, 56, 39, 41, 65, 22, 89, 81],
                  //     borderColor: "#39CCCC",
                  //     // backgroundColor: "rgb(0,0,135)",
                  //     backgroundColor: "#39CCCC",
                  //     yAxisID: "y",
                  //     tension: 0.5,
                  //   },
                  //   {
                  //     label: "Active",
                  //     data: [76, 29, 92, 61, 60, 52, 46, 87, 59, 90, 81],
                  //     borderColor: "#D81B60",
                  //     // backgroundColor: "rgb(117,217,239)",
                  //     backgroundColor: "#D81B60",
                  //     yAxisID: "y1",
                  //     tension: 0.5,
                  //   },
                  //   {
                  //     label: "In Process",
                  //     data: [50, 17, 60, 44, 26, 14, 29, 15, 59, 89, 51],
                  //     borderColor: "#FF851B",
                  //     // backgroundColor: "rgb(80,108,120)",
                  //     backgroundColor: "#FF851B",
                  //     yAxisID: "y1",
                  //     tension: 0.5,
                  //   },
                  //   {
                  //     label: "Rejected",
                  //     data: [10, 9, 37, 41, 21, 28, 11, 35, 24, 67, 61],
                  //     borderColor: "#605CA8)",
                  //     // backgroundColor: "rgb(216,217,221)",
                  //     backgroundColor: "#605CA8",
                  //     yAxisID: "y1",
                  //     tension: 0.5,
                  //   },
                  // ],
                });
              }
            }
          }
          // setOpen(false);
        } else {
          setDataGraph([]);
          setOpen(false);
        }
      } catch (error) {
        setDataGraph([]);
        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      setDataGraph([]);

      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/message/table/today-yesterday/graph`,
          {
            dashBoardRequest: {
              // startDate: "2023-08-01",
              // endDate: "2023-08-31",
              dailyCode:
                Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
              flag: "Failed",
            },
          }
        );

        if (res.data?.statusDescription.statusCode == 200) {
          // TableDataGet1();

          setRowData(res.data?.dataSets);
          setLabelDate(res.data.xaxixLabelHour);
          setOpen(false);
          // localStorage.removeItem("dashboardTopTabs")
          if (res.data?.dataSets?.length == 0) {
            setDataGraph([]);
            setOpen(false);
          } else {
            let varrr = false;
            res.data["dataSets1"] = [];
            for (let index = 0; index < res.data?.dataSets?.length; index++) {
              res.data.dataSets[index]["pointRadius"] = 0;
              res.data.dataSets[index]["clicked"] = true;

              if (res.data.dataSets[index].label == "Dnd") {
                res.data.dataSets[index]["backgroundColor"] = "#536878";
                res.data.dataSets[index]["borderColor"] = "#536878";
                res.data.dataSets[index]["icon"] = BlockIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;

                res.data.dataSets[index]["pointHoverRadius"] = 6;
                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#536878";
              }
              if (res.data.dataSets[index].label == "Blacklist") {
                res.data.dataSets[index]["backgroundColor"] = "#221133";
                res.data.dataSets[index]["borderColor"] = "#221133";
                res.data.dataSets[index]["icon"] = CancelIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;
                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#221133";
              }
              if (res.data.dataSets[index].label == "Nack") {
                res.data.dataSets[index]["backgroundColor"] = "#a40000";
                res.data.dataSets[index]["borderColor"] = "#a40000";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;

                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#a40000";
              }


              if (res.data.dataSets[index].label == "System Error") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f";
                res.data.dataSets[index]["borderColor"] = "#f9442f";
                res.data.dataSets[index]["icon"] =
                  SystemSecurityUpdateWarningIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;

                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "#f9442f";
              }
              if (res.data.dataSets[index].label == "Message Sent") {
                res.data.dataSets[index]["backgroundColor"] = "#f9442f";
                res.data.dataSets[index]["borderColor"] = "#f9442f";
                res.data.dataSets[index]["icon"] = StopCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
              }
              if (res.data.dataSets[index].label == "Waiting For ACK") {
                res.data.dataSets[index]["backgroundColor"] = "orange";
                res.data.dataSets[index]["borderColor"] = "orange";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
                res.data.dataSets[index]["pointStyle"] = "circle";
                res.data.dataSets[index]["pointRadius"] = 4;
                res.data.dataSets[index]["pointHoverRadius"] = 6;
                res.data.dataSets[index]["pointBackgroundColor"] = "white";
                res.data.dataSets[index]["pointBorderColor"] = "orange";
              }
              if (res.data.dataSets[index].label == "Delivered") {
                res.data.dataSets[index]["backgroundColor"] = "#5ab778";
                res.data.dataSets[index]["borderColor"] = "#5ab778";
                res.data.dataSets[index]["icon"] = CheckCircleIcon;
                res.data["dataSets1"].push(res.data.dataSets[index]);
              }
              for (
                let i = 0;
                i < res.data?.dataSets[index]?.data?.length;
                i++
              ) {
                if (res.data?.dataSets[index]?.data[i] != 0) {
                  varrr = true;
                }
              }
            }
            if (!varrr) {
              setDataGraph([]);
            } else {
              if (value[1] != "successM") {
                setDataGraph({
                  labels: res.data?.xaxixLabelHour,

                  datasets: res.data?.dataSets1,
                });
              }
            }
          }
          // setOpen(false);
        } else {
          setDataGraph([]);
          setOpen(false);
        }
      } catch (error) {
        // console.error({ error });

        setDataGraph([]);

        setOpen(false);
        // console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  };

  // ..............................................................................................................//
  async function TodayTableget() {
    // setData([]);
    let temp = [];
    let Sno = {
      Header: "Id",
      accessor: "id",
      Cell: (cell) => {
        // console.log(
        //   "cell--==",
        //   cell.row.index + 1,
        //   cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize
        // );
        return (
          <>
            {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
          </>
        );
      },
    };
    setSerialNo(Sno);
    // let dateColumn = {

    //     Header: "Date",

    //     accessor: "Date",
    //     Cell: (cell) => {
    //       return (
    //         <>
    //           <Link

    //             style={{
    //               textDecoration: "underline",
    //               // color: "blue",
    //               fontWeight: "bolder",
    //             }}
    //             to={`/dashboard/TransactionalReport/All`}
    //           >
    //             {cell?.row?.original?.Date}
    //           </Link>

    //         </>
    //       );

    //   },
    // }
    let downloadColumn = {
      Header: "Download",
      accessor: "download",
      // Cell: ({ row }) => (
      //   <button>Download</button>
      // ),
      Cell: (cell) => {
        return (
          <>
            {cell.row.original.Download == null ? (
              <>
                <div className="">
                  <button
                    type="button"
                    className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
                    id="btn_Update"
                    style={{ width: "auto" }}
                    onClick={() => {
                      DownloadAction(cell);
                    }}
                    // disabled={DownloadDisable}
                  >
                    {/* Download Request */}
                    <DownloadingSharpIcon />
                    
                  </button>
                </div>
              </>
            ) : cell.row.original.Download === "" ? (
              <>
                <Box
                  sx={{ display: "block", width: "100px" }}
                  className="mx-auto"
                >
                  <CircularProgress style={{ width: "31px", height: "31px" }} />
                </Box>
              </>
            ) : (
              <>
                <div className="">
                  <button
                    className="btn color_1 px-2"
                    type="button"
                    id=""
                    data-bs-toggle=""
                    aria-expanded="false"
                    onClick={() => {
                      downloadFile(cell);
                    }}
                  >
                    <FileDownloadIcon />
                  </button>
                </div>
              </>
            )}
          </>
        );
      },
    };
    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/today-yesterday/message/status`,
        {
          p_status: value[1] == "successM" ? [3, 4] : [2, 4],
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        await setHeaderColumn(result.data.messageStatusTables);
        temp.push(Sno);
        // temp.push(dateColumn);
        for (let i = 0; i < result.data.messageStatusTables.length; i++) {
          if (result.data.messageStatusTables[i].columnName == "Hour") {
            temp.push({
              Header: result.data.messageStatusTables[i].columnName,
              accessor: result.data.messageStatusTables[i].columnName,
              Cell: (cell) => {
                return (
                  <>
                    {value[1] == "successM" ? (
                      <>
                        <Link
                          style={{
                            textDecoration: "underline",
                            // color: "blue",
                            fontWeight: "bolder",
                          }}
                          to={`/dashboard/SuccessGraph/SuccessGraphReports`}
                          onClick={() => {
                            localStorage.setItem(
                              "dailyCode",
                              `${cell.row.original.Hour}`
                            );
                          }}
                        >
                          {cell?.row?.original?.Hour}
                        </Link>
                      </>
                    ) : (
                      <>
                        <Link
                          style={{
                            textDecoration: "underline",
                            // color: "blue",
                            fontWeight: "bolder",
                          }}
                          to={`/dashboard/FailedGraph/FailedGraphReports`}
                          onClick={() => {
                            localStorage.setItem(
                              "dailyCode",
                              `${cell.row.original.Hour}`
                            );
                          }}
                        >
                          {cell?.row?.original?.Hour}
                        </Link>
                        
                      </>
                    )}
                  </>
                );
              },
            });
          } else if (result.data.messageStatusTables[i].columnName == "S.No") {
          } else if (
            result.data.messageStatusTables[i].columnName == "Download detail report"
          ) {
            temp.push({
              Header: result.data.messageStatusTables[i].columnName,
              accessor: result.data.messageStatusTables[i].columnName,
              Cell: (cell) => {
                return (
                  <>
                    {cell.row.original.Download == null ? (
                      <>
                        <div className="">
                          <button
                            type="button"
                            className="btn btn_wt_8 btn_update mx-auto m-0  radius d-flex align-items-center"
                            id="btn_Update"
                            style={{ width: "auto" }}
                            onClick={() => {
                              DownloadAction(cell);
                            }}
                            // disabled={DownloadDisable}
                          >
                            <DownloadingSharpIcon />
                          </button>
                        </div>
                      </>
                    ) : cell.row.original.Download === "" ? (
                      <>
                        <Box
                          sx={{ display: "block", width: "100px" }}
                          className="mx-auto"
                        >
                          <CircularProgress
                            style={{ width: "31px", height: "31px" }}
                          />
                        </Box>
                      </>
                    ) : (
                      <>
                        <div className="">
                          <button
                            className="btn color_1 px-2"
                            type="button"
                            id=""
                            data-bs-toggle=""
                            aria-expanded="false"
                            onClick={() => {
                              downloadFile(cell);
                            }}
                          >
                            <FileDownloadIcon />
                          </button>
                        </div>
                      </>
                    )}
                  </>
                );
              },
            });
          } else {
            temp.push({
              Header: result.data.messageStatusTables[i].columnName,
              accessor: result.data.messageStatusTables[i].columnName,
            });
          }
        }
        // temp.splice(1, 1);
        // temp.push(downloadColumn);
        // console.log("temp--", temp);
        // const indexToRemove = temp.length - 2;
        // if (indexToRemove >= 0) {
        //   temp.splice(indexToRemove, 1);
        // }
        setColumns(temp);

        // await setHeaderColumn1(result.data.fileUploads);
      } else {
        setOpen(false);
        setHeaderColumn([]);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }
  useEffect(() => {
    let dynamicColumns = [...columns];
    let Sno = {
      Header: "Id",
      accessor: "id",
      Cell: (cell) => {
        // console.log(
        //   "cell--==",
        //   cell.row.index + 1,
        //   cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize
        // );
        return (
          <>
            {cell.row.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
          </>
        );
      },
    };
    dynamicColumns[0] = Sno;
    setColumns(dynamicColumns);
  }, [TableStatus.pageNo, TableStatus.pageSize]);

  useEffect(() => {
    if ((Tabs == "3" || Tabs == "4") && TodayGraphApiNotHit == false) {
      TodayTableget();

    } else {
      Tableget();
    }
  }, [Status?.dateTabs0]);
 useEffect(()=>{
setAnchorEll(false)
 },[resd?.timeSeries2?.buttonClicked])
  // ..........................................................................................//

  async function TodayTableDataGet() {
    setData([]);
    setOpen1(true);

    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/table/v1/get/today-yesterday/message/data`,
        // {
        //   status: value[1] == "successM" ? 3 : 2,
        // }
        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
          dashBoardRequest: {
            reportType:
              value[1] == "successM" ? "Today Success" : "Today Failed",
            // dailyCode: resd?.timeSeries2?.start,
            dailyCode:
              Tabs == "3" ? resd?.timeSeries2?.start : resd?.timeSeries2?.end,
          },
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        setData(result.data.succesOrFailedMessageTableDatas.content);
        setData1(result.data.succesOrFailedMessageTableDatas);
        setOpen1(false);
      } 
      else if (result.data.statusDescription.statusCode == 220){
        setOpen1(false);
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: result.data.statusDescription.statusMessage,
        // });
      }
      else {
        setOpen1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setOpen1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }
  const [ViewTableForm, setViewTableForm] = React.useState(false);
  const [anchorEl4, setAnchorEl4] = React.useState(null);
  const openmenue4 = Boolean(anchorEl4);
  const downloadRef_revenuecost = useRef(null);
  const downloadRef_revenuecost_graph = useRef(null);

  const [isFullScreen, setFullScreen] = useState(false);
     console.log("dh8", setAnchorEl4);
  const downloadRef_revenuecost_child = useRef(null);
  const [RevenueCostData, setRevenueCostData] = useState(null);
  const handleClosemenue4 = () => {
    setAnchorEl4(null);
  };
  const handleClickmenue4 = (event) => {
    setAnchorEl4(event.currentTarget);
  };
  // const handleClosemenue = () => {
  //   setAnchorEl(null);
  // };

  const enterFullScreen = () => {
    handleClosemenue4();
    // setgloblecancel(true)
    setFullScreen(true)
    const element = document.getElementById("revenucostgraphFull");
    if (element) {
      if (element.requestFullscreen) {
        element
          .requestFullscreen()
          .then(() => setFullScreen(true))
          .catch((error) => console.log("Error entering full-screen:", error));
      } else if (element.webkitRequestFullscreen) {
        // Safari
        element
          .webkitRequestFullscreen()
          .then(() => setFullScreen(true))
          .catch((error) => console.log("Error entering full-screen:", error));
      } else if (element.msRequestFullscreen) {
        // Internet Explorer
        element
          .msRequestFullscreen()
          .then(() => setFullScreen(true))
          .catch((error) => console.log("Error entering full-screen:", error));
      } else {
        setFullScreen(false);
      }
    }
  };

  
  const downloadChartAsPDF_revenucostDATA = async () => {
    handleClosemenue4();
    // const element = downloadRef_revenuecost.current;
    // html2canvas(element, { scale: 2 }).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");
    //   const pdf = new jsPDF("p", "mm", "a4");
    //   const pdfWidth = 190;
    //   const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    //   pdf.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight);
    //   if (value[1] == "successM") {
    //     pdf.save("SuccessGraph.pdf");
    //   } else {
    //     pdf.save("FailedGraph.pdf");
    //   }
    // });

    const canvas1 = await html2canvas(downloadRef_revenuecost_graph.current, { scale: 2 });
    const imgData1 = canvas1.toDataURL("image/png");
    // const pdf = new jsPDF("p", "mm", "a4");
    const pdf = new jsPDF("p", "pt", [320, 500]);
    const pdfWidth = 270;
    const pdfHeight1 = (canvas1.height * pdfWidth) / canvas1.width;
    pdf.addImage(imgData1, "PNG", 20, 20, pdfWidth, pdfHeight1);
    // pdf.addImage(imgData1, "PNG", 10, 10);
  
    // Add a page for section 2
    pdf.addPage();
  
    // Capture section 2
    const canvas2 = await html2canvas(downloadRef_revenuecost.current, { scale: 2 });
    const imgData2 = canvas2.toDataURL("image/png");

    const pdfHeight2 = (canvas2.height * pdfWidth) / canvas2.width;
    pdf.addImage(imgData2, "PNG", 20, 20, pdfWidth, pdfHeight2);
    // pdf.addImage(imgData2, "PNG", 10, 10);
    // Save the PDF
    // pdf.save("combined_sections.pdf");
    if (value[1] == "successM") {
          pdf.save("SuccessGraph.pdf");
        } else {
          pdf.save("FailedGraph.pdf");
        }

  };
  const downloadChartAsimage_revenucostDATA = async () => {
    const element = downloadRef_revenuecost_graph.current;
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement('a');
      link.href = imgData;
      link.download = 'Image.png';
      // if (value[1] == "successM") {
      //   link.download("SuccessGraphImage.png");
      // } else {
      //   link.download("FailedGraphImage.png");
      // }
      link.click();
    });
  };

  // Capture section 1

  
  const downloadChartAsPDF_revenucostDATA_forTable = async () => {
    //  for img
    setOpen(true);
    handleClosemenue4();
    const element = downloadRef_revenuecost_child.current;

    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", [320, 500]);
      const pdfWidth = 300;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      if (pdf) {
        setOpen(false);
      }
      pdf.addImage(imgData, "PNG", 20, 20, pdfWidth, pdfHeight);
      pdf.save("Revenue & Cost.pdf");
    });
  };

  const exitFullScreen = () => {
    handleClosemenue4();
    if (document.exitFullscreen) {
      document
        .exitFullscreen()
        .then(() => setFullScreen(false))
        .catch((error) => console.log("Error exiting full-screen:", error));
    } else if (document.webkitExitFullscreen) {
      // Safari
      document
        .webkitExitFullscreen()
        .then(() => setFullScreen(false))
        .catch((error) => console.log("Error exiting full-screen:", error));
    } else if (document.msExitFullscreen) {
      // Internet Explorer
      document
        .msExitFullscreen()
        .then(() => setFullScreen(false))
        .catch((error) => console.log("Error exiting full-screen:", error));
    } else {
      setFullScreen(false);
    }
  };

  const handleClickExcel_revenucostDATA = () => {
    // Create workbook and worksheet
    handleClosemenue4();

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet([]);

    // Set headers
    const headers = [
      "Date",
      ...dataGraph.datasets.map((series) => series.label),
    ];
    XLSX.utils.sheet_add_json(worksheet, [headers], { skipHeader: true });

    // Set data
    const rows = dataGraph.labels.map((xAxis, index) => {
      const rowData = [
        xAxis,
        ...dataGraph.datasets.map((series) => series.data[index]),
      ];
      return rowData;
    });
    XLSX.utils.sheet_add_json(worksheet, rows, {
      skipHeader: true,
      origin: "A2",
    });

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Generate the Excel file
    if (value[1] == "successM") {
      XLSX.writeFile(workbook, "SuccessGraph.xlsx");
    } else {
      XLSX.writeFile(workbook, "FailedGraph.xlsx");
    }
  };
  useEffect(() => {
    window.addEventListener("resize", function () {
      if (window.innerHeight >= window.screen.height - 20) {
        console.log("The browser is in fullscreen mode");
        if (globlecancel) {
          setFullScreen(true);
        }
      } else {
        console.log("The browser is NOT in fullscreen mode");
        setFullScreen(false);
        setgloblecancel(false);
      }

      // console.log('her')
    });
  }, []); 
  return (
    <>
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        // open={open1}
        open={open}

        // onClick={handleClose}
      >
        <Loader />
      </Backdrop>
      <div>
        <button
          // ref={modelButtonApprove}
          ref={modelButtonDownload}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop2"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal fade"
          id="staticBackdrop2"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdrop2Label"
          aria-hidden="true"
        >
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdrop2Label">
                  Download Request
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                {/* Are you sure you want to download the report ? */}
                Are you sure you want to initiate the download request ?
              </div>

              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary shadow"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary editcolor shadow okbtn"
                  data-bs-dismiss="modal"
                  // onClick={() => {
                  //   DownloadButtonApi
                  // }}
                  onClick={DownloadActionget}
                >
                  Download Request
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid py-3">
        <div className="card" id="canvas_card">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
              <PersonIcon
                style={{
                  color: "white",
                  fontSize: "27px",
                }}
              />
            </div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ marginLeft: "6rem" }}
            >
              {/* <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
               Success Graph
              </p> */}

              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                {localStorage.getItem("dstQueCode1")?.split(",")?.[1] ==
                "campaign"
                  ? "Campaign Report"
                  : localStorage.getItem("dstQueCode1")?.split(",")?.[1] ==
                    "failedM"
                  ? "Failed Graph"
                  : "Success Graph"}
              </p>
              <div className="d-flex align-items-center">
                <div className="my-auto me-4">
                  <div class="datePickerButtonsDashboard">
                    {[
                      // {
                      //   name: "Yesterday",
                      //   startdateValue: "",
                      //   enddateValue: "",
                      // },
                      {
                        name: "1D",
                        startdateValue: moment().format("YYYY-MM-DD"),
                        enddateValue: moment().format("YYYY-MM-DD"),
                        dateTypee: "Daily",
                        tooltipText: "1 Day",
                      },

                      {
                        name: "1W",
                        startdateValue: moment(addDays(new Date(), -6)).format(
                          "YYYY-MM-DD"
                        ),
                        enddateValue: moment().format("YYYY-MM-DD"),
                        dateTypee: "Daily",
                        tooltipText: "1 Week",
                      },

                      {
                        name: "1M",
                        enddateValue: moment().format("YYYY-MM-DD"),
                        startdateValue: moment(addDays(new Date(), -29)).format(
                          "YYYY-MM-DD"
                        ),

                        dateTypee: "Month",
                        startDateMonth: moment(
                          startOfMonth(addMonths(new Date(), -1))
                        ).format("YYYYMM"),
                        endDateMonth: moment().format("YYYYMM"),
                        tooltipText: "1 Month",
                      },
                      {
                        name: "3M",
                        startdateValue: moment(
                          addMonths(new Date(), -3)
                        ).format("YYYY-MM-DD"),
                        enddateValue: moment().format("YYYY-MM-DD"),
                        dateTypee: "Monthly",
                        tooltipText: "3 Months",
                      },

                      {
                        name: "6M",
                        startdateValue: moment(
                          addMonths(new Date(), -6)
                        ).format("YYYY-MM-DD"),
                        enddateValue: moment().format("YYYY-MM-DD"),
                        dateTypee: "Monthly",
                        tooltipText: "6 Months",
                      },
                    ].map((dataaa, index) => {
                      return (
                        <a
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={dataaa.tooltipText}
                          onClick={() => {
                         
                            // let admission = moment(
                            //   dataaa?.startdateValue,
                            //   "YYYY-MM-DD"
                            // );
                            // let discharge = moment(
                            //   dataaa?.enddateValue,
                            //   "YYYY-MM-DD"
                            // );
                            // let admission1 = moment(
                            //   resd?.timeSeries1?.start,
                            //   "YYYY-MM-DD"
                            // );
                            // let discharge1 = moment(
                            //   resd?.timeSeries1?.end,
                            //   "YYYY-MM-DD"
                            // );

                            // console.log(
                            //   discharge.diff(admission, "days"),
                            //   discharge1.diff(admission1, "days")
                            // );
                            dispatch(
                              setTimeSeries2({
                                start: dataaa?.startdateValue,
                                end: dataaa?.enddateValue,
                                dateType: resd?.timeSeries2?.dateType,
                                buttonClicked:
                                  !resd?.timeSeries2?.buttonClicked,
                                  dateReset:dataaa.name,
                              })
                            );
                            setTableStatus({
                              ...TableStatus,
                         
                              pageNo: 0,
                              pageSize:10,
                            });
                            setStatus({
                              ...Status,
                              dateTabs0: dataaa,
                              pageNo: 0,
                            });
                            setPaginationPage(1);
                            if (dataaa.name == "1D") {
                              // localStorage.setItem("dashboardTopTabs", "3");
                              setTodayGraphApiNotHit(false);

                            } else {
                              setTodayGraphApiNotHit(true);
                            }
                          }}
                          // className={`${(function () {
                          //   let admission = moment(
                          //     dataaa?.startdateValue,
                          //     "YYYY-MM-DD"
                          //   );
                          //   let discharge = moment(
                          //     dataaa?.enddateValue,
                          //     "YYYY-MM-DD"
                          //   );
                          //   let admission1 = moment(
                          //     resd?.timeSeries2?.start,
                          //     "YYYY-MM-DD"
                          //   );
                          //   let discharge1 = moment(
                          //     resd?.timeSeries2?.end,
                          //     "YYYY-MM-DD"
                          //   );
                          //   const val =
                          //     discharge.diff(admission, "days") ===
                          //     discharge1.diff(admission1, "days")
                          //       ? "active"
                          //       : "";

                          //   return val;
                          // })()}`}

                          className={`${(function () {
                            let admission = moment(
                              dataaa?.startdateValue,
                              "YYYY-MM-DD"
                            );
                            let discharge = moment(
                              dataaa?.enddateValue,
                              "YYYY-MM-DD"
                            );
                            let admission1 = moment(
                              resd?.timeSeries2?.start,
                              "YYYY-MM-DD"
                            );
                            let discharge1 = moment(
                              resd?.timeSeries2?.end,
                              "YYYY-MM-DD"
                            );

                            // const val =
                            //  ( discharge.diff(admission, "days") ===
                            //   discharge1.diff(admission1, "days") && resd?.timeSeries2?.start < moment().format("YYYY-MM-DD"))
                            //     ? "" : ( discharge.diff(admission, "days") ===
                            //   discharge1.diff(admission1, "days") && resd?.timeSeries2?.end >= moment().format("YYYY-MM-DD")) ?
                            //   "active"
                            //     : "";

                            // return val;
                            // console.log('ad--==',discharge.diff(admission, "days"))

                            if (
                              resd?.timeSeries2?.start == resd?.timeSeries2?.end
                            ) {
                              if (
                                discharge.diff(admission, "days") ===
                                discharge1.diff(admission1, "days")
                              ) {
                                if (
                                  resd?.timeSeries2?.start <
                                  moment().format("YYYY-MM-DD")
                                ) {
                                  return "";
                                } else {
                                  return "active";
                                }
                              }
                            } else {
                              if (
                                discharge.diff(admission, "days") ===
                                discharge1.diff(admission1, "days")
                              ) {
                                if (
                                  resd?.timeSeries2?.end >=
                                  moment().format("YYYY-MM-DD")
                                ) {
                                  return "active";
                                } else {
                                  return "";
                                }
                              }
                            }
                          })()}`}
                        >
                          {" "}
                          {dataaa.name}
                        </a>
                      );
                    })}
                  </div>
                </div>

                <div className=" text-end">
                  <span
                    style={{ backgroundColor: "#3c8dbc", color: "white" }}
                    className="d-sm-inline ms_2 start_date_time_css"
                  >
                    {selectedTime.start}
                  </span>
                  <ForwardIcon />
                  <span
                    style={{ backgroundColor: "#3c8dbc", color: "white" }}
                    className="d-sm-inline mx_2 start_date_time_css"
                  >
                    {selectedTime.end}
                  </span>

                  <IconButton
                    variant="text"
                    size="small"
                    sx={{
                      color: "rgba(0, 0, 0, 0.6)",
                    }}
                    aria-describedby={
                      Boolean(anchorEll) ? "simple-popover" : undefined
                    }
                    onClick={(event) => {
                      setAnchorEll(event.currentTarget);
                    }}
                  >
                    <CalendarMonthIcon />
                  </IconButton>

                  <Popover
                    id={Boolean(anchorEll) ? "simple-popover" : undefined}
                    open={Boolean(anchorEll)}
                    anchorEl={anchorEll}
                    onClose={() => {
                      setAnchorEll(null);
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <DateRangePickerGraph />
                  </Popover>
                </div>

             
              </div>
            </div>
          </div>

          <div className="card-body px-3" >
            {!open && dataGraph ? (
              <>
                <div id="revenucostgraphFull" ref={downloadRef_revenuecost_graph} style={{background: "white"}}>
                  {" "}
                  {dataGraph.length == 0 ? (
                    <div className="d-flex h-100 p-3">
                      <div className="m-auto text-center">
                        <h1 style={{fontSize:'29px'}}>No Data</h1>
                        <img
                          style={{ width: "83px", maxWidth: "100%" }}
                          src={CancelImg}
                          alt=""
                          srcset=""
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="d-flex flex-wra justify-content-between mt-2 " id="icon_dashboard">
                      <div className="d-flex justify-content-center align-items-center w-100">
                        {dataGraph?.datasets?.map((dataaa, index) => {
                          return (
                            <div>
                              <Button
                                className="me-3"
                                size="small"
                                sx={{
                                  borderRadius: 2,
                                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                                  backgroundColor: chartRef?.current?.data
                                    ?.datasets?.[index]?.hidden
                                    ? "grey"
                                    : dataaa.backgroundColor,
                                  color: "white",
                                  textDecorationColor: "black",
                                  textDecoration: chartRef?.current?.data
                                    ?.datasets?.[index]?.hidden
                                    ? "line-through"
                                    : "none",
                                  color: "white",
                                }}
                                variant="contained"
                                startIcon={
                                  dataaa.icon ? (
                                    <dataaa.icon />
                                  ) : (
                                    <CheckCircleIcon />
                                  )
                                }
                                onClick={() => {
                                  handleButtonClick(index);
                                }}
                              >
                                {dataaa?.label}
                              </Button>
                            </div>
                          );
                        })}
                        </div>
<div className="d-flex align-items-center" style={{flex:'0 0 auto'}}>
                        {isFullScreen ? (
                          <>
                            <div className="d-block">
                              <CancelIcon onClick={exitFullScreen} />
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        <div className="my-auto me-4">
                  <div class="datePickerButtonsDashboard">
                    {[
                      // {
                      //   name: "Yesterday",
                      //   startdateValue: "",
                      //   enddateValue: "",
                      // },
                      {
                        name: "line",
                        tooltipText: "Line Graph",
                        icon: <ShowChartIcon/>
                        
                      },

                      {
                        name: "bar",
                        tooltipText: "Bar Graph",
                        icon:<BarChartIcon/>
                      },

                      
                    ].map((dataaa, index) => {
                      return (
                        <a
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={dataaa.tooltipText}
                          onClick={() => {
                          setBarIcons(dataaa.name)
                          }}
                          className={
                            dataaa.name == barIcons ? "active" : ""
                          }
                        >
                          {" "}
                          {dataaa.icon}
                        </a>
                      );
                    })}
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mb-">
                                  <>
                                    {" "}
                                    <IconButton
                                      aria-label="more"
                                      id="long-button"
                                      aria-controls={
                                        openmenue4 ? "long-menu" : undefined
                                      }
                                      aria-expanded={
                                        openmenue4 ? "true" : undefined
                                      }
                                      aria-haspopup="true"
                                      onClick={handleClickmenue4}
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                  </>
                         

                                <Menu
                                  id="long-menu"
                                  MenuListProps={{
                                    "aria-labelledby": "long-button",
                                  }}
                                  style={{ zIndex: "9999999999" }}
                                  anchorEl={anchorEl4}
                                  open={openmenue4}
                                  onClose={handleClosemenue4}
                                  PaperProps={{
                                    style: {
                                      width: "auto",
                                      borderRadius:'17px',
                                      
                                    },
                                  }}
                                  transformOrigin={{
                                    horizontal: "right",
                                    vertical: "top",
                                  }}
                                  anchorOrigin={{
                                    horizontal: "right",
                                    vertical: "bottom",
                                  }}
                                >
                                  <MenuItem
                                    onClick={handleClickExcel_revenucostDATA}
                                  >
                                    {/* Save{" "}
                                    {ViewTableForm == true
                                      ? "Table"
                                      : "Graph  "}{" "}
                                    Data (Excel) */}
                                    <DescriptionIcon style={{color:"Green", width:'1em !important', height:'1em !important'}} />
                                    Data in Excel
                                  </MenuItem>

                                  <MenuItem
                                    onClick={
                                    
                                        downloadChartAsPDF_revenucostDATA
                                    }
                                  >
                                    {/* Save{" "}
                                    {ViewTableForm == true
                                      ? "Table"
                                      : "Graph Image "}{" "}
                                    (PDF) */}
                                    <PictureAsPdfIcon style={{color:"Red", width:'1em !important', height:'1em !important'}}/>
                                    Data in PDF
                                  </MenuItem>

                                  <MenuItem onClick={enterFullScreen}>
                                  <AssessmentIcon style={{color:"#2191d0", width:'1em !important', height:'1em !important'}}/>
                                    View Full{" "}
                                    {ViewTableForm == true
                                      ? "Table"
                                      : "Graph  "}
                                      
                                  </MenuItem>
                                  <MenuItem
                                    onClick={
                                      downloadChartAsimage_revenucostDATA }
                                  >
                                  <ImageIcon style={{color:"orange", width:'1em !important', height:'1em !important'}}/>
                                    {/* Save{" "}
                                    {ViewTableForm == true
                                      ? "Table"
                                      : "Graph Image "}{" "}
                                    (IMAGE) */}
                                    Data in PNG
                                  </MenuItem>
                                </Menu>
                              </div> 
                              </div>
                      </div>
                      <Chart
                        type={barIcons}
                        options={options}
                        data={dataGraph}
                        onClick={handleClick}
                        ref={chartRef}
                      />
                    </>
                  )}{" "}
                </div>
              </>
            ) : (
              <>
                <Skeleton animation="wave" className="mt-3" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
              </>
            )}

            <div className="p-4">
              {/* {dataGraph?.length == 0 ? (
                <>
                  <Skeleton animation="wave" className="mt-3" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                </>
              ) : (
                <> */}
              {/* <div className="revenucostprofit table-responsive">
             

                <table>
                  <thead>
                    <tr>
                      {headerColumn.map((header, index) => (
                        <th key={index}>{header.columnName}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {dataa.map((item, index) => (
                      <tr key={index}>
                        {headers.map((header, idx) => (
                          <td key={idx}>{item[header]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div> */}
              {/* </>
              )} */}

              {open1 == true ? (
                <>
                  <Skeleton animation="wave" className="mt-3" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                </>
              ) : (
                <>
                  {(data?.length > 0 && dataGraph?.datasets?.length > 0) ? (
                    <>
                      <div className="d-flex justify-content-between mt-3">
                        <select
                          value={TableStatus.pageSize}
                          className="dropdown"
                          onChange={(e) => {
                            setPageSize(Number(e.target.value));
                            setTableStatus({
                              ...TableStatus,
                              pageSize: e.target.value,
                              pageNo: 0,
                            });
                            
                            setByDefaultTableApiNotHit(true);
                          }}
                        
                        >
                          {[10, 25, 50].map((value, i) => {
                            return (
                              <option
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                                value={value}
                                key={value}
                              >
                                Show {value}
                              </option>
                            );
                          })}
                        </select>
                        <div className="my-auto">
                          {/* <Tooltip title="Refresh"> */}
                          <button
                            type="submit"
                            className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                            // onClick={RefreshBtn}
                            onClick={() => RefreshBtn("Text to Copy")}
                          >
                            {/* <i class="material-icons opacity-10">refresh</i> */}
                            <RefreshIcon />
                          </button>
                          {/* </Tooltip> */}
                        </div>
                      </div>
                      <div class="table-responsive mt-3">
                        <table
                          {...getTableProps()}
                          id="example"
                          className="table blacklisting_table table-striped table-bordered dataTable table-sm"
                          style={{ width: "100%" }}
                          ref={downloadRef_revenuecost}
                        >
                          <thead>
                            {headerGroups.map((headerGroup) => (
                              <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                  <th
                                    {...column.getHeaderProps(
                                      column.getSortByToggleProps()
                                    )}
                                    className="text-center width_2"
                                  >
                                    {column.render("Header")}
                                    <span>
                                      {column.isSorted
                                        ? column.isSortedDesc
                                          ? "↑"
                                          : "↓"
                                        : ""}
                                    </span>
                                  </th>
                                ))}
                              </tr>
                            ))}
                          </thead>
                          <tbody class='onhover_change' {...getTableBodyProps()}>
                            {page.map((row) => {
                              prepareRow(row);
                              return (
                                <tr {...row.getRowProps()}>
                                  {row.cells.map((cell) => {
                                    return (
                                      <td
                                        {...cell.getCellProps()}
                                        className={
                                          cell.column.Header == "Id" ||
                                          cell.column.Header ==
                                            "Total Upload" ||
                                          cell.column.Header ==
                                            "Total Success" ||
                                          cell.column.Header ==
                                            "Total Failure" ||
                                          cell.column.Header == "Allready Exist"
                                            ? "text-end"
                                            : cell.column.Header ==
                                                "Download detail report" ||
                                              cell.column.Header ==
                                                "Delivered" ||
                                              cell.column.Header ==
                                                "Waiting For ACK" ||
                                              cell.column.Header ==
                                                "Pushed To SMSC" ||
                                              cell.column.Header ==
                                                "System Error" ||
                                              cell.column.Header == "Nack" ||
                                              cell.column.Header ==
                                                "Blacklist" ||
                                              cell.column.Header == "Dnd"
                                            ? "text-center"
                                            : "text-start"
                                        }
                                      >
                                        <div>{cell.render("Cell")}</div>
                                      </td>
                                    );
                                  })}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex justify-content-between mt -2">
                        <div>
                          <span>
                            Page:
                            <strong>
                              {data1?.pageable?.pageNumber + 1} of{" "}
                              {data1?.totalPages}
                            </strong>
                          </span>
                        </div>

                        <div className="prev_next d-flex align-items-center">
                          <button
                            className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                            type="button"
                            onClick={() => {
                              setByDefaultTableApiNotHit(true);
                              setTableStatus({
                                ...TableStatus,
                                pageNo: 0,
                              });
                              setPaginationPage(1);
                            }}
                          >
                            First
                          </button>

                          <Stack spacing={2}>
                            <Pagination
                              onChange={(event, value) => {
                                setByDefaultTableApiNotHit(true);
                                setTableStatus({
                                  ...TableStatus,
                                  pageNo: Number(value) - 1,
                                });
                                setPaginationPage(value);
                              }}
                              page={paginationPage}
                              count={data1 ? data1?.totalPages : ""}
                              variant="outlined"
                              shape="rounded"
                              color="primary"
                            />
                          </Stack>
                          <button
                            className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                            type="button"
                            onClick={() => {
                              setByDefaultTableApiNotHit(true);
                              setTableStatus({
                                ...TableStatus,
                                pageNo: data1?.totalPages - 1,
                              });
                              setPaginationPage(data1?.totalPages);
                            }}
                          >
                            Last
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* {data?.length == 0 && (open || open1) ? null : (
                        <div className="text-center mt-4">
                          <h5>No Record Found..!!</h5>
                        </div>
                      )} */}
                      {data?.length == 0 && (open || open1)
                        ? null
                        : dataGraph.length != 0 && (
                            <>
                              <div className="text-center mt-4">
                                <h5>No Record Found..!!</h5>
                              </div>
                            </>
                          )}
                      {/* <div className="text-center mt-4">
                        {data?.length == 0 &&
                        open == true ? null : data?.length == 0 &&
                          open == undefined ? null : (
                          <div className="text-center">
                            <h5>No Record Found..!!</h5>
                          </div>
                        )}
                      </div> */}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
































